// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:31:02.330Z
// Property: The Elliott (ID: 5638944016302080)
// Collections: 20 amenities, 7 floorplans (live), 32 photos, 82 POIs, 5 reviews, 7 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5638944016302080",
  "property_external_id": "4917513",
  "property_zillow_url": "https://www.zillow.com/apartments/concord-nc/delaney/5Xr94t/",
  "property_apartments_url": "https://www.apartments.com/the-elliott-concord-nc/zjegkly",
  "property_google_business_url": "https://www.google.com/maps/place/The+Elliott/@35.4425307,-80.6598347,17z/data=!4m13!1m7!3m6!1s0x885405bfa00c7757:0x21c6eaed6f2c64b7!2s4600+Mba+Ct,+Concord,+NC+28027!3b1!8m2!3d35.4425307!4d-80.6576407!3m4!1s0x885405bf0a98e2af:0x1c8ebda93c6119dc!8m2!3d35.4425025!4d-80.6576793",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443201070",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-elliott",
  "property_name": "The Elliott",
  "property_website_url": "https://www.theelliottnc.com/",
  "property_domain": "https://www.theelliottnc.com/",
  "property_address": "4600 Mba Ct",
  "property_full_address": "4600 Mba Ct, Concord, NC 28027",
  "property_address_1": "4600 Mba Ct",
  "property_address_2": null,
  "property_address_city": "Concord",
  "property_address_state": "NC",
  "property_address_zip_full": "28027-8307",
  "property_address_zip": "28027",
  "property_address_country": "US",
  "property_address_county": "Cabarrus County",
  "property_neighborhood_address": "Outlying Cabarrus County",
  "property_address_latitude": "35.4421414",
  "property_address_longitude": "-80.6573502",
  "property_email": "elliott@alapts.com",
  "property_phone": "(704) 793-1332",
  "property_call_tracking_phone": "980-485-5765",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Concord convenience with room to live well.</strong> Discover one-, two-, and three-bedroom apartments with polished finishes, everyday comforts, and easy access to I-85 and Concord Mills—then explore spacious floor plans or schedule your tour.</p>",
  "property_long_description": "<p><strong>Concord convenience with room to live well.</strong> At The Elliott, you’re close to I-85 and Concord Mills while coming home to a polished apartment community with the everyday extras that make routines feel easier. Choose a one-, two-, or three-bedroom layout with 9-foot ceilings, crown molding, in-home washer and dryer, fully equipped kitchens with quartz or granite countertops, and private patios, balconies, or sunrooms in select homes.</p><p>Beyond your front door, <a href=\"/amenities\">amenities</a> bring resort-style ease: a relaxing pool with Wi-Fi hotspots, modern 24-hour fitness center, clubhouse with billiards, 20-seat theater, EV charging, package lockers, grilling areas, car wash station, and a bark park with pet wash. When you’re ready to explore, Concord Mills offers shopping, dining, and entertainment, Charlotte Motor Speedway adds signature motorsports energy, and nearby Gibson Mill brings a food hall, craft breweries, antiques, and local retail to the Concord scene. Browse <a href=\"/floor-plans\">spacious floor plans</a> or see more of the area on the <a href=\"/neighborhood\">neighborhood</a> page.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ee-e459-7656-bcd7-f685ee24f2d9.webp",
  "property_featured_image_media": {
    "alt_text": "Living room with a large sectional sofa, coffee table, TV, and a dining area visible through an archway.",
    "public_id": "019d02ee-e459-7656-bcd7-f685ee24f2d9",
    "storage_key": "property/5638944016302080/019d02ee-e459-7656-bcd7-f685ee24f2d9.webp",
    "width": 1920,
    "height": 1280
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "240",
  "property_year_built": "2010",
  "property_year_renovated": "2022",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Application Fee $75\nAdministrative Fee $150\nNon-Refundable Pet Fee $300 / pet\nMonthly Pet Rent $30 / pet\nApplication Approval Fee Starting At $399\n",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8813098.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://theelliott.loftliving.com/login",
  "property_apply_now_url": "https://8813098.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ee-a19f-73d2-9fb8-3e14f2c8073d.webp",
  "property_primary_logo_media": {
    "alt_text": "The Elliott Premier Apartment Homes logo.",
    "public_id": "019d02ee-a19f-73d2-9fb8-3e14f2c8073d",
    "storage_key": "property/5638944016302080/019d02ee-a19f-73d2-9fb8-3e14f2c8073d.webp",
    "width": 1920,
    "height": 1080
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02f0-5a9a-776c-9af0-1ec42a93ff10.webp",
  "property_secondary_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02f0-5a9a-776c-9af0-1ec42a93ff10",
    "storage_key": "property/5638944016302080/019d02f0-5a9a-776c-9af0-1ec42a93ff10.webp",
    "width": 325,
    "height": 147
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e7075-5b43-7467-8c1a-3ddafa927904.webp",
  "property_icon_media": {
    "alt_text": "The e logo",
    "public_id": "019e7075-5b43-7467-8c1a-3ddafa927904",
    "storage_key": "property/5638944016302080/019e7075-5b43-7467-8c1a-3ddafa927904.webp",
    "width": 2564,
    "height": 2564
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e7075-5b43-7467-8c1a-3ddafa927904.webp",
  "property_fav_icon_media": {
    "alt_text": "The e logo",
    "public_id": "019e7075-5b43-7467-8c1a-3ddafa927904",
    "storage_key": "property/5638944016302080/019e7075-5b43-7467-8c1a-3ddafa927904.webp",
    "width": 2564,
    "height": 2564
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ee-9fb7-70ff-94ab-1a5afaed160c.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Elliott Premier Apartment Homes logo.",
    "public_id": "019d02ee-9fb7-70ff-94ab-1a5afaed160c",
    "storage_key": "property/5638944016302080/019d02ee-9fb7-70ff-94ab-1a5afaed160c.webp",
    "width": 400,
    "height": 200
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f43c4-52c6-732f-98f0-4103bf2a5719.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f43c4-52c6-732f-98f0-4103bf2a5719",
    "storage_key": "property/5638944016302080/019f43c4-52c6-732f-98f0-4103bf2a5719.webp",
    "width": 1280,
    "height": 720
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#6d3844",
  "property_secondary_color": "#3b3848",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#6b0f36",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "851 - 1485",
  "property_sqft_min": "851",
  "property_sqft_max": "1485",
  "property_price_range": "1613 - 1734",
  "property_price_min": "1613",
  "property_price_max": "1734",
  "property_available_units": 12,
  "property_facebook_url": "https://www.facebook.com/TheElliottApts",
  "property_instagram_url": "https://www.instagram.com/theelliottaptsconcord",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJr-KYCr8FVIgR3BlhPKm9jhw",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/the-elliott-concord",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Amenities with serious range.</strong> Start with a 24-hour fitness center, poolside Wi-Fi, clubhouse billiards, and a 20-seat movie theater with a 120-inch screen. Add EV charging, parcel lockers, a car wash area, and pet-friendly perks like a bark park and pet washing station. Inside, 9-foot ceilings, in-home laundry, quartz or granite countertops, walk-in closets, and select patios, balconies, or sunrooms bring everyday comfort home.</p>",
  "property_home_floorplans_blurb": "<p><strong>Room to choose, details to love.</strong> Explore one-, two-, and three-bedroom apartments at The Elliott with polished finishes and everyday ease, including in-home washers and dryers, fully equipped kitchens with built-in microwaves, quartz or granite countertops, 9-foot ceilings with crown molding, walk-in closets, and select sunrooms or private outdoor space.</p>",
  "property_home_gallery_blurb": "<p><strong>See The Elliott in focus.</strong> Preview bright living rooms with crown molding, kitchens with subway tile and stone-style countertops, and outdoor spaces made for unwinding—from poolside loungers to landscaped courtyards. The gallery also spotlights polished community spaces like the clubhouse, billiard room, resident kitchen, theater-style media room, mural-accented fitness center, and select balconies, patios, and sunrooms.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Connected north Concord, with room to breathe.</strong> From The Elliott, Afton Ridge, I-85, Frank Liske Park, local greenways, and Downtown Concord’s Union Street are all within easy reach. Shop, dine, commute, or unwind outdoors—then come home to a polished apartment setting in Outlying Cabarrus County. Explore the neighborhood map to see what’s nearby.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents notice the follow-through.</strong> Reviews highlight responsive service, from leasing questions answered with care to maintenance requests handled quickly—sometimes within minutes. Team members like Kayla, Logan, Nash, Janiyah, and Paige are often mentioned by name.</p><p>Residents also praise the well-kept community, easy touring and move-in experience, and amenities like the movie theater. See why one review says The Elliott “always felt like home.”</p>",
  "property_neighborhood_blurb": "<p><strong>Start with an easy north Concord rhythm.</strong> From The Elliott, your map fills in quickly: Afton Ridge for everyday shopping and dinner plans, I-85 for trips toward Charlotte or Kannapolis, and Concord’s growing mix of local hangouts when you want something different. Spend a free afternoon at Frank Liske Park, follow the city’s greenway network, or head toward Downtown Concord for coffee, storefronts, and arts events along Union Street.</p><p>Here, Outlying Cabarrus County feels connected without losing its breathing room—close to retail, restaurants, parks, and commuter routes, with a polished apartment community waiting when you return. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the location fits your day.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity spaces that work hard for your day.</strong> At The Elliott, you can move from a 24-hour fitness session to poolside Wi-Fi, a clubhouse game of billiards, or a movie night in the 20-seat theater with a 120-inch screen—without leaving the community. Practical extras like EV charging stations, parcel lockers, a car wash area, online resident services, and on-site maintenance help keep daily routines simple.</p><p>Inside your Concord apartment, polished details add comfort where it counts: 9-foot ceilings with crown molding, in-home washer and dryer, fully equipped kitchens with quartz or granite countertops, walk-in closets, and private patios, balconies, or sunrooms in select layouts. Pet-friendly features, including a bark park and pet washing station, add even more convenience. See the spaces in the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience them in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready for Concord convenience with room to live well?</strong> Start your online application for The Elliott and move closer to polished one-, two-, or three-bedroom living with 9-foot ceilings, in-home laundry, elevated kitchen finishes, and everyday community extras that make home feel easy.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> The Elliott team is here to help you connect with Concord convenience, spacious one-, two-, and three-bedroom layouts, and polished everyday features. Reach out today for leasing details, availability, or help planning your visit.</p>",
  "property_faqs_blurb": "<p><strong>Questions about life at The Elliott?</strong> Start here for quick answers on the community, leasing, apartment features, amenities, and everyday conveniences. If you don’t see what you need, the leasing team is happy to help you take the next step.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits the way you live.</strong> The Elliott’s one-, two-, and three-bedroom floor plans give you a clear range of options, from streamlined one-bedroom homes to expansive two- and three-bedroom layouts with extra room to spread out. As you compare availability, look for everyday comforts that make each space feel complete: in-home washer and dryer, fully equipped kitchens with built-in microwaves, quartz or granite countertops, 9-foot ceilings with crown molding, walk-in closets, and private outdoor space or sunrooms in select homes.</p><p>Choose a layout with the bedroom count, storage, and flow that works for your routine, then explore the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite Concord apartment floor plan in person.</p>",
  "property_gallery_blurb": "<p><strong>Picture the details before you visit.</strong> The Elliott’s gallery brings the community into focus, from light-filled living rooms with crown molding to kitchens framed by sleek appliances, subway tile, and stone-style countertops. Browse poolside loungers, landscaped courtyards, and shaded outdoor seating, then step inside the clubhouse to spot the billiard room, resident kitchen, and theater-style media space that give the community its polished feel.</p><p>As you scroll, imagine your day moving from a workout in the mural-accented fitness center to a quiet moment on a balcony, patio, or sunroom. When a photo catches your eye, compare available <a href=\"/floor-plans\">one-, two-, and three-bedroom layouts</a>, explore the <a href=\"/virtual-tours\">virtual tours</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see The Elliott in Concord up close.</p>",
  "property_interactivemap_blurb": "<p><strong>Map out your next move.</strong><br>Use the interactive map to explore available one-, two-, and three-bedroom apartments at The Elliott, then see how close Concord convenience puts you to I-85, Concord Mills, and more local dining, shopping, and entertainment.</p>",
  "property_pets_blurb": "<p><strong>Room to roam, rinse, and relax.</strong> At The Elliott, pet-friendly living is built into the everyday rhythm—not added as an afterthought. Cats and dogs are welcome with no weight limit, so your home search can focus on comfort, space, and convenience. Start the day with a stroll through the community, let your dog enjoy the on-site bark park, then make cleanups easier at the pet washing station after outdoor time.</p><p>Inside, spacious layouts give pets and people room to settle in, with select homes offering private patios, balconies, or sunrooms for a little fresh-air downtime. When you want to see how the pet-friendly spaces fit your routine, browse the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> in Concord.</p>",
  "property_referafriend_blurb": "<p><strong>Share Concord convenience with room to live well.</strong> Love your spacious layout, polished finishes, and everyday extras at The Elliott? Invite a friend to experience the same easy routines, from in-home comfort to resort-style community spaces, and help them find their next apartment here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at The Elliott.</strong><br>Pay rent, submit maintenance requests, and manage your account in one convenient place—so everyday routines stay as polished and easy as life at The Elliott.</p>",
  "property_reviews_blurb": "<p><strong>See what stands out in residents’ own words.</strong> Reviews for The Elliott consistently point to responsive, people-first service—from helpful leasing support to maintenance that follows through. Residents call out Kayla, Logan, Nash, Janiyah, and Paige for answering questions, checking in after work orders, and handling requests with urgency and care.</p><p>You’ll also see praise for a well-kept community, a smooth touring and move-in process, timely maintenance—sometimes within minutes—and amenities residents enjoy, including the movie theater. One reviewer summed it up simply: The Elliott “always felt like home.” Browse the ratings and firsthand experiences below to get a clearer sense of daily life here.</p>",
  "property_created_at": "1752256361768",
  "property_scheduletour_blurb": "<p><strong>See Concord convenience up close.</strong> Tour The Elliott and get a feel for spacious layouts, 9-foot ceilings, polished finishes, and everyday extras designed to simplify your routine. Schedule your visit today and picture how home can look here.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong><br>The leasing team will follow up soon. In the meantime, picture coming home to Concord convenience, polished one-, two-, and three-bedroom layouts, in-home laundry, elevated finishes, and resort-style spaces that make everyday routines feel easier at The Elliott.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through The Elliott on your own time.</strong> Explore the spaces that shape the day-to-day experience, from the resort-style pool and polished clubhouse to the movie theater, CrossFit gym, and spin studio. The virtual tours let you move at your pace, pause on the details, and picture how each setting feels before you visit in person.</p><p>Inside the apartment tours, compare the B3 and B1 two-bedroom layouts with a closer look at open living areas, kitchen finishes, bedroom placement, and storage flow. Start here for a realistic preview of apartments in Concord, then browse <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready to see more.</p>",
  "property_copyright": "2025 All Rights Reserved. The Elliott",
  "property_seo_title_home": "Home | The Elliott",
  "property_seo_description_home": "Experience luxury living at The Elliott in Concord, NC! Choose from spacious 1-3 bedroom floor plans with top-notch amenities. Your perfect home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Concord, NC Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at The Elliott in Concord, NC! Choose from stylish one, two, or three-bedroom floor plans tailored for your comfort. Browse now!",
  "property_seo_title_amenities": "Amenities | Concord, NC Apartments for Rent",
  "property_seo_description_amenities": "Experience modern living at The Elliott in Concord, NC! Enjoy luxurious amenities, from a refreshing pool to a pet-friendly playground. Your dream home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Concord, NC",
  "property_seo_description_gallery": "Picture life at The Elliott in Concord, NC! Enjoy modern amenities, spacious floor plans, and a vibrant community. Your perfect home awaits with stunning views!",
  "property_seo_title_virtualtours": "Virtual Tours | The Elliott Apartments",
  "property_seo_description_virtualtours": "Step into The Elliott in Concord, NC! Experience spacious one, two, and three-bedroom apartments. Join us for a virtual tour today!",
  "property_seo_title_interactivemap": "Interactive Map | The Elliott Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at The Elliott in Concord, NC! Use our interactive map to explore spacious floor plans and premium amenities designed for your lifestyle.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Concord, NC",
  "property_seo_description_neighborhood": "Uncover the charm of Concord, NC, around The Elliott. Dive into local favorites and hidden gems just steps from your new home. Your neighborhood awaits!",
  "property_seo_title_contact": "Contact Us | The Elliott",
  "property_seo_description_contact": "Connect with The Elliott in Concord, NC! Explore our one, two, and three-bedroom floor plans. Have questions? Our leasing team is here to help!",
  "property_seo_title_faqs": "FAQs | Apartments in Concord, NC",
  "property_seo_description_faqs": "Your questions about The Elliott in Concord, NC are answered! Explore our FAQs to learn about amenities, floor plans, and living life to the fullest here.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Concord, NC",
  "property_seo_description_reviews": "At The Elliott in Concord, NC, our residents love the lifestyle! From luxurious amenities to spacious floor plans, see why they call us home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Concord, NC",
  "property_seo_description_applynow": "Elevate your lifestyle at The Elliott in Concord, NC! Choose from spacious floor plans, enjoy top-notch amenities, and lease your new home online today!",
  "property_seo_title_residentaccess": "Resident Access | The Elliott",
  "property_seo_description_residentaccess": "Unlock convenience at The Elliott! Manage rent, request maintenance, and connect with neighbors in our easy-to-use resident portal. Your home, your way!",
  "property_seo_title_referafriend": "Refer A Friend | The Elliott",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to The Elliott in Concord, NC, and enjoy a vibrant community together. Share the joy of living here!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Elliott",
  "property_seo_description_scheduletour": "Experience modern living at The Elliott in Concord, NC. Schedule a tour today and find your perfect apartment in our vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | The Elliott",
  "property_seo_description_privacy": "Your privacy matters at The Elliott in Concord, NC. Learn how we protect your information. Stay informed—view our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | The Elliott",
  "property_seo_description_accessibility": "Experience seamless living at The Elliott in Concord, NC. We prioritize accessibility for all, ensuring everyone feels at home. Join our inclusive community today!",
  "property_seo_title_sitemap": "Sitemap | The Elliott",
  "property_seo_description_sitemap": "Uncover a world of comfort at The Elliott in Concord, NC. Navigate our sitemap to find your perfect home and embrace effortless living today!",
  "property_seo_title_thankyou": "Thank You | The Elliott",
  "property_seo_description_thankyou": "Thank you for reaching out to The Elliott in Concord, NC! Our team will connect with you soon to help you find your perfect home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Buford, GA\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793651138663",
  "amenities": [
    {
      "id": "custom_ddc5c49b-157e-4807-b2df-2aef28ce8b4e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Quartz Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_973a9473-c325-4fac-ac40-902f5ca25ef4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Washer and Dryers",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2d79724e-3ee9-49ef-9305-e40cdbce33fc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Stain Resistant Carpeting & Wood Style Floors",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b35bfd3d-6b0a-429b-9761-b9961a072e89",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patios, Balconies & Sunrooms",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3a2e6e51-435c-4c74-b08d-6ebcd4e49931",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "external_id": "P000000603",
      "title": "Blinds",
      "amount": "0.0000",
      "description": "2\" Faux Wood Blinds",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6f06fb14-0564-4b85-a775-03f09d4248d6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "external_id": "P000000606",
      "title": "Built-In Microwave",
      "amount": "0.0000",
      "description": "Fully Equipped Kitchens w/ Built-In Microwaves",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ce3ebfff-eb29-4513-859b-6587b175fc75",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "external_id": "P000000641",
      "title": "Garden Tub",
      "amount": "0.0000",
      "description": "Garden Soaking Tubs*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cc24ef5b-a41b-4ae7-8f9f-c6d2f113e900",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "external_id": "P000000624",
      "title": "Crown Molding",
      "amount": "0.0000",
      "description": "9' Ceilings w/ Crown Molding",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_21141b5e-8686-409b-bd40-081b5790f26a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_604fb2a5-2c15-466d-b292-ff1c50cd3494",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Relaxing Pool w/ WiFi Hotspots",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_92033399-93a6-408a-b9e3-bbf651a3be73",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Bark Park for your Furry Friends",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9720ffe1-216b-4b7f-8fd2-668c98a0d820",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern 24-Hour Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5750a40e-e9d4-4791-889a-54107ebce9d6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "external_id": "P000000145",
      "title": "LUXER Package Locker",
      "amount": "0.0000",
      "description": "Parcel Pending Package Lockers",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_93de0bf9-919c-4f0a-b7bb-c54a8ce713a4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "external_id": "P000000610",
      "title": "Car Charging Stations",
      "amount": "0.0000",
      "description": "Electric Car Charging Stations",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bc795a75-231a-496e-b882-6e1caa3ecce7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "external_id": "P000000640",
      "title": "Garages",
      "amount": "0.0000",
      "description": "Carriage Style Homes w/Attached Garages",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5c6cd328-d952-4c98-b85b-3e3bd31d5ee4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "external_id": "P000000644",
      "title": "Grill Area",
      "amount": "0.0000",
      "description": "Gourmet Outdoor Grilling & Picnic Area",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2ed04150-0344-4c8c-a070-f975364114be",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "external_id": "P000000693",
      "title": "Theatre Room",
      "amount": "0.0000",
      "description": "20-Seat Theater w/ 120\" Screen",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4d0ec65e-571b-406e-8da7-f5596ff0e111",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "external_id": "P000002380",
      "title": "Billiards Room",
      "amount": "0.0000",
      "description": "Clubhouse w/ Billiard Room",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2e574c76-429f-439a-9b26-7e599fe3d4dd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_372cd77f-31f0-45e2-a7c7-cf1c77c68819",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_29e7d0d0-9d55-403f-8582-ab5ae5a33ac5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e89f6-9958-763f-8d60-fa040e18cfa2.webp",
      "image_media": {
        "alt_text": "Luxury movie theater with reclining seats and a large screen.",
        "public_id": "019e89f6-9958-763f-8d60-fa040e18cfa2",
        "storage_key": "property/5638944016302080/019e89f6-9958-763f-8d60-fa040e18cfa2.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy movie nights in our resident exclusive luxury movie theater, complete with comfortable reclining seating and a large screen for an immersive cinematic experience.",
      "link": "",
      "alt_text": "Luxury movie theater with reclining seats and a large screen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_951ade34-ccaa-4ea1-a4cb-152e0509313b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e89f6-9650-72f5-ab61-f80b6ab9298c.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a glass-enclosed shower, toilet, and vanity with granite countertops.",
        "public_id": "019e89f6-9650-72f5-ab61-f80b6ab9298c",
        "storage_key": "property/5638944016302080/019e89f6-9650-72f5-ab61-f80b6ab9298c.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Step into this elegant bathroom featuring a spacious glass-enclosed shower, a modern vanity with granite countertops, and tasteful decor.",
      "link": "",
      "alt_text": "Modern bathroom with a glass-enclosed shower, toilet, and vanity with granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_714ff870-9649-409f-bd4e-911c59422549",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e89f6-94c0-7230-9b97-b1bd2a7660d1.webp",
      "image_media": {
        "alt_text": "Primary bedroom with a king-sized bed, walk-in closet, and ensuite bathroom.",
        "public_id": "019e89f6-94c0-7230-9b97-b1bd2a7660d1",
        "storage_key": "property/5638944016302080/019e89f6-94c0-7230-9b97-b1bd2a7660d1.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Relax in the spacious primary bedroom, complete with a plush king-sized bed, ample closet space, and a private ensuite bathroom.",
      "link": "",
      "alt_text": "Primary bedroom with a king-sized bed, walk-in closet, and ensuite bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8a2c3e3b-692e-4abf-9ec5-8f52e91eaa6b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e89f6-8941-751a-a14c-46ef64598e4c.webp",
      "image_media": {
        "alt_text": "Stylish lounge area with a large brown sofa, fireplace, and white armchairs.",
        "public_id": "019e89f6-8941-751a-a14c-46ef64598e4c",
        "storage_key": "property/5638944016302080/019e89f6-8941-751a-a14c-46ef64598e4c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our elegant community lounge, featuring a modern fireplace and comfortable seating.",
      "link": "",
      "alt_text": "Stylish lounge area with a large brown sofa, fireplace, and white armchairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fd830829-d26c-46b7-b321-a6f4af5ab0d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e89f6-94bc-7558-abb7-c10d43325e90.webp",
      "image_media": {
        "alt_text": "Modern resident lounge with coffee bar, seating area, and fireplace.",
        "public_id": "019e89f6-94bc-7558-abb7-c10d43325e90",
        "storage_key": "property/5638944016302080/019e89f6-94bc-7558-abb7-c10d43325e90.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish resident lounge, featuring a fully equipped coffee bar, comfortable seating, and a cozy fireplace.",
      "link": "",
      "alt_text": "Modern resident lounge with coffee bar, seating area, and fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f24f5854-3d74-4508-a77f-58e470caab3b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e89f6-85e1-760e-843c-654b4c7f5a29.webp",
      "image_media": {
        "alt_text": "Stylish home office with a wooden desk, white chairs, and modern art.",
        "public_id": "019e89f6-85e1-760e-843c-654b4c7f5a29",
        "storage_key": "property/5638944016302080/019e89f6-85e1-760e-843c-654b4c7f5a29.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Create your ideal workspace in this elegantly appointed home office, featuring a spacious desk, comfortable seating, and chic decor.",
      "link": "",
      "alt_text": "Stylish home office with a wooden desk, white chairs, and modern art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9fc77959-80fb-4006-9a3c-c2b3da025f5f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e89f6-8623-7368-b160-6550a51b94a3.webp",
      "image_media": {
        "alt_text": "Well-equipped fitness center with cardio machines, weight racks, kettlebells, medicine balls, and battle ropes.",
        "public_id": "019e89f6-8623-7368-b160-6550a51b94a3",
        "storage_key": "property/5638944016302080/019e89f6-8623-7368-b160-6550a51b94a3.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring everything you need for a complete workout.",
      "link": "",
      "alt_text": "Well-equipped fitness center with cardio machines, weight racks, kettlebells, medicine balls, and battle ropes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_62e3775b-7d22-41e6-83e3-ec0a06cf1cdc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e89f6-82fc-704d-9df6-e1b7c3c7dc21.webp",
      "image_media": {
        "alt_text": "Modern kitchen with gray and white cabinets, stainless steel appliances, and quartz countertops.",
        "public_id": "019e89f6-82fc-704d-9df6-e1b7c3c7dc21",
        "storage_key": "property/5638944016302080/019e89f6-82fc-704d-9df6-e1b7c3c7dc21.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience culinary excellence in our modern kitchens, featuring sleek gray and white cabinetry, premium quartz countertops, and top-of-the-line stainless steel appliances.",
      "link": "",
      "alt_text": "Modern kitchen with gray and white cabinets, stainless steel appliances, and quartz countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2acd715b-3128-4323-a7b5-d285f402ccee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e89f6-740c-75ef-b2cc-4c5f23e72200.webp",
      "image_media": {
        "alt_text": "Cozy bedroom featuring a king-size bed with a mustard-yellow knit throw, a white dresser, a closet, and a large abstract painting.",
        "public_id": "019e89f6-740c-75ef-b2cc-4c5f23e72200",
        "storage_key": "property/5638944016302080/019e89f6-740c-75ef-b2cc-4c5f23e72200.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in this inviting bedroom, complete with a plush king-size bed, a stylish accent chair, and ample closet space. Perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Cozy bedroom featuring a king-size bed with a mustard-yellow knit throw, a white dresser, a closet, and a large abstract painting.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e271a98c-2763-4baa-8b63-359a06a209d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e89f6-6ee5-76ef-9b9b-c7a77cf1489d.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with modern lounge chairs and a circular table on a stone patio with a grassy courtyard and building in the background.",
        "public_id": "019e89f6-6ee5-76ef-9b9b-c7a77cf1489d",
        "storage_key": "property/5638944016302080/019e89f6-6ee5-76ef-9b9b-c7a77cf1489d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish outdoor lounge area, featuring comfortable seating and a beautiful courtyard setting perfect for enjoying the fresh air.",
      "link": "",
      "alt_text": "Outdoor seating area with modern lounge chairs and a circular table on a stone patio with a grassy courtyard and building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6017041d-83ce-4012-8cfd-37014c0c3b59",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e89f6-76b6-714d-822d-a8aab8244097.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs under a pergola.",
        "public_id": "019e89f6-76b6-714d-822d-a8aab8244097",
        "storage_key": "property/5638944016302080/019e89f6-76b6-714d-822d-a8aab8244097.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy sunny days by the resort-style pool, complete with comfortable lounge chairs and shaded pergolas for ultimate relaxation.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs under a pergola.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_91622bb0-78d2-42c1-b80e-10dad2eab39c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e89f6-6a51-726b-a5ef-a60988645aa9.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and seating area.",
        "public_id": "019e89f6-6a51-726b-a5ef-a60988645aa9",
        "storage_key": "property/5638944016302080/019e89f6-6a51-726b-a5ef-a60988645aa9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and a shaded seating area for enjoying the sunshine.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_56b6a448-7935-409b-9d3e-3e3e717f191b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e89f6-66c6-700f-9c50-3809c592c57a.webp",
      "image_media": {
        "alt_text": "Fitness room with stationary bikes, exercise balls, and resistance bands.",
        "public_id": "019e89f6-66c6-700f-9c50-3809c592c57a",
        "storage_key": "property/5638944016302080/019e89f6-66c6-700f-9c50-3809c592c57a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center. Enjoy cardio machines, free weights, and yoga mats.",
      "link": "",
      "alt_text": "Fitness room with stationary bikes, exercise balls, and resistance bands.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1fc77871-6672-49c7-b24c-ed00d5071169",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e89f6-6596-71ab-ae41-98d9a060c75b.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a pool table, large dining table with bar stools, and abstract art.",
        "public_id": "019e89f6-6596-71ab-ae41-98d9a060c75b",
        "storage_key": "property/5638944016302080/019e89f6-6596-71ab-ae41-98d9a060c75b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy leisure time in our community lounge, featuring a billiards table and a stylish dining area perfect for gatherings.",
      "link": "",
      "alt_text": "Modern lounge area with a pool table, large dining table with bar stools, and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_220f83ca-6abd-4799-9688-95d1ec7ad347",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e89f6-6a34-71b7-8cc2-75136215a3a9.webp",
      "image_media": {
        "alt_text": "Spacious living room with a sectional sofa, coffee table, and entertainment center.",
        "public_id": "019e89f6-6a34-71b7-8cc2-75136215a3a9",
        "storage_key": "property/5638944016302080/019e89f6-6a34-71b7-8cc2-75136215a3a9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy relaxing in this beautifully furnished living room, featuring a comfortable sectional sofa, a stylish coffee table, and a modern entertainment center perfect for unwinding.",
      "link": "",
      "alt_text": "Spacious living room with a sectional sofa, coffee table, and entertainment center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7d253e1a-ed10-4aad-a6e3-bfa05287127f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e89f6-65b0-7214-b39f-7d43855fa73f.webp",
      "image_media": {
        "alt_text": "Primary bedroom with a four-poster bed, plush bedding, and a dark accent wall.",
        "public_id": "019e89f6-65b0-7214-b39f-7d43855fa73f",
        "storage_key": "property/5638944016302080/019e89f6-65b0-7214-b39f-7d43855fa73f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience ultimate comfort in our spacious primary bedrooms, featuring a luxurious four-poster bed and elegant decor. Schedule a tour today!",
      "link": "",
      "alt_text": "Primary bedroom with a four-poster bed, plush bedding, and a dark accent wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e5c53b46-f6ff-473e-9630-1de774a6f49c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e89f6-67c5-7570-9b0e-db4d9fbd5afe.webp",
      "image_media": {
        "alt_text": "Modern kitchen and dining area with breakfast bar and banquette seating.",
        "public_id": "019e89f6-67c5-7570-9b0e-db4d9fbd5afe",
        "storage_key": "property/5638944016302080/019e89f6-67c5-7570-9b0e-db4d9fbd5afe.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience the perfect blend of style and functionality in this well-appointed kitchen and dining area, featuring a spacious breakfast bar and cozy banquette seating.",
      "link": "",
      "alt_text": "Modern kitchen and dining area with breakfast bar and banquette seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f11615b1-4074-4437-92d7-97c0f9c08f65",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e89f6-3a4a-7274-a14b-7b4b3c52a53b.webp",
      "image_media": {
        "alt_text": "Dog park with green turf and a pink shaded structure.",
        "public_id": "019e89f6-3a4a-7274-a14b-7b4b3c52a53b",
        "storage_key": "property/5638944016302080/019e89f6-3a4a-7274-a14b-7b4b3c52a53b.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Spacious dog park with durable green turf, perfect for your furry friends to play and relax. Features a shaded area for comfort.",
      "link": "",
      "alt_text": "Dog park with green turf and a pink shaded structure.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_222aeb5a-feaa-4167-ab59-5a6c002f4dc6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e89f6-5a0a-723a-8c58-a7b9e4d5432c.webp",
      "image_media": {
        "alt_text": "Modern kitchen and dining area with stainless steel appliances, white cabinets, and a breakfast nook with a round table.",
        "public_id": "019e89f6-5a0a-723a-8c58-a7b9e4d5432c",
        "storage_key": "property/5638944016302080/019e89f6-5a0a-723a-8c58-a7b9e4d5432c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy cooking and dining in this stylish apartment kitchen, featuring sleek stainless steel appliances, ample cabinet space, and a cozy breakfast nook perfect for casual meals or morning coffee.",
      "link": "",
      "alt_text": "Modern kitchen and dining area with stainless steel appliances, white cabinets, and a breakfast nook with a round table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_68085bc2-b7c6-48a4-a75e-6b742a72f0cb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e89f6-46ff-745c-bedf-ba11e70b69ae.webp",
      "image_media": {
        "alt_text": "Spacious living room with a plush green sectional sofa, wooden media console, and large windows.",
        "public_id": "019e89f6-46ff-745c-bedf-ba11e70b69ae",
        "storage_key": "property/5638944016302080/019e89f6-46ff-745c-bedf-ba11e70b69ae.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed living room, featuring a stylish sectional sofa and ample natural light.",
      "link": "",
      "alt_text": "Spacious living room with a plush green sectional sofa, wooden media console, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6c95ac9f-9914-4e06-9d71-7ce3d100d046",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e89f6-39e3-71d5-b677-52ecdf1c08e3.webp",
      "image_media": {
        "alt_text": "Billiard table in a community lounge area",
        "public_id": "019e89f6-39e3-71d5-b677-52ecdf1c08e3",
        "storage_key": "property/5638944016302080/019e89f6-39e3-71d5-b677-52ecdf1c08e3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy some friendly competition in our community billiard room, the perfect place to relax and socialize with neighbors.",
      "link": "",
      "alt_text": "Billiard table in a community lounge area",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5911451b-b0b5-4f52-a28b-77d83ee1326d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e89f6-5705-7748-88ed-adedbf5d72d4.webp",
      "image_media": {
        "alt_text": "Modern gym with treadmills, weight racks, and graffiti art on the wall.",
        "public_id": "019e89f6-5705-7748-88ed-adedbf5d72d4",
        "storage_key": "property/5638944016302080/019e89f6-5705-7748-88ed-adedbf5d72d4.webp",
        "width": 2152,
        "height": 1434
      },
      "title": "Community",
      "description": "Equipped with state-of-the-art cardio machines, free weights, and weightlifting stations, this gym offers a dynamic workout space with a unique graffiti mural.",
      "link": "",
      "alt_text": "Modern gym with treadmills, weight racks, and graffiti art on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4461dd53-ed39-4efa-8200-3d99c3b9cf78",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e89f6-39d9-75da-93d4-5de942cd42b4.webp",
      "image_media": {
        "alt_text": "The Elliott apartment building package lockers.",
        "public_id": "019e89f6-39d9-75da-93d4-5de942cd42b4",
        "storage_key": "property/5638944016302080/019e89f6-39d9-75da-93d4-5de942cd42b4.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Secure package lockers for residents at The Elliott Premier Apartment Homes.",
      "link": "",
      "alt_text": "The Elliott apartment building package lockers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7fe6083f-dc60-4b5a-9988-f5f2a7814ee4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e89f6-396a-77ed-9bd9-d8a15bc57f9d.webp",
      "image_media": {
        "alt_text": "Gym with weight racks, free weights, exercise machines, and graffiti art.",
        "public_id": "019e89f6-396a-77ed-9bd9-d8a15bc57f9d",
        "storage_key": "property/5638944016302080/019e89f6-396a-77ed-9bd9-d8a15bc57f9d.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with cardio equipment, weight training stations, and dynamic graffiti art.",
      "link": "",
      "alt_text": "Gym with weight racks, free weights, exercise machines, and graffiti art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_315580f0-7f47-453f-a5a2-57cddbf27a91",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e89f6-3967-767b-99be-ca982842b360.webp",
      "image_media": {
        "alt_text": "Exterior view of a multifamily apartment building with fall foliage and a parking lot.",
        "public_id": "019e89f6-3967-767b-99be-ca982842b360",
        "storage_key": "property/5638944016302080/019e89f6-3967-767b-99be-ca982842b360.webp",
        "width": 2732,
        "height": 1820
      },
      "title": "Community",
      "description": "Exterior view of a multifamily apartment building featuring architectural details and seasonal foliage, with a paved parking area in the foreground.",
      "link": "",
      "alt_text": "Exterior view of a multifamily apartment building with fall foliage and a parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c2bf5b03-48a5-4942-aa59-d1e9e4d9e2a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e89f6-3965-707c-87ae-54c9b7947d03.webp",
      "image_media": {
        "alt_text": "Closet with white towels and robe",
        "public_id": "019e89f6-3965-707c-87ae-54c9b7947d03",
        "storage_key": "property/5638944016302080/019e89f6-3965-707c-87ae-54c9b7947d03.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving, storage baskets, a plush robe, and a stool for convenience. Organize your belongings in style.",
      "link": "",
      "alt_text": "Closet with white towels and robe",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_893058d1-8c2c-4ab0-b872-e5db9e9d209d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e89f6-3966-7113-ab12-28a52715c5e0.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer with storage shelves above",
        "public_id": "019e89f6-3966-7113-ab12-28a52715c5e0",
        "storage_key": "property/5638944016302080/019e89f6-3966-7113-ab12-28a52715c5e0.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Enjoy the convenience of an in-unit washer and dryer, complemented by ample storage space for all your laundry essentials.",
      "link": "",
      "alt_text": "In-unit washer and dryer with storage shelves above",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_50855bf9-bcc7-44ea-9465-36a1c3718969",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e89f6-4410-748c-b02f-ff5815664bbb.webp",
      "image_media": {
        "alt_text": "Modern kitchen with gray and white cabinets, stainless steel appliances, and a breakfast bar.",
        "public_id": "019e89f6-4410-748c-b02f-ff5815664bbb",
        "storage_key": "property/5638944016302080/019e89f6-4410-748c-b02f-ff5815664bbb.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Open-concept kitchen featuring modern gray and white cabinetry, stainless steel appliances, and a spacious quartz countertop breakfast bar, seamlessly connecting to the living area.",
      "link": "",
      "alt_text": "Modern kitchen with gray and white cabinets, stainless steel appliances, and a breakfast bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4ee44a67-afce-416b-824f-2fa9d7486b23",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e89f6-4291-731c-88f8-c695e70836a1.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and covered cabanas.",
        "public_id": "019e89f6-4291-731c-88f8-c695e70836a1",
        "storage_key": "property/5638944016302080/019e89f6-4291-731c-88f8-c695e70836a1.webp",
        "width": 2186,
        "height": 1456
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning resort-style swimming pool, surrounded by comfortable lounge chairs and shaded cabanas.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and covered cabanas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dff772e5-a3ec-4afa-8ae4-d7e3e6703a65",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e89f6-274d-77cf-96a4-f2505c9b6145.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a bathtub, toilet, and vanity with a granite countertop.",
        "public_id": "019e89f6-274d-77cf-96a4-f2505c9b6145",
        "storage_key": "property/5638944016302080/019e89f6-274d-77cf-96a4-f2505c9b6145.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Freshen up in this chic bathroom, featuring a soaking tub, elegant vanity with granite countertops, and ample natural light.",
      "link": "",
      "alt_text": "Modern bathroom with a bathtub, toilet, and vanity with a granite countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d05794a8-2d9a-4d8c-b86e-0b60695fba3b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e89f6-2a5c-71fc-a0dd-2d5ed91342b3.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and built-in grills.",
        "public_id": "019e89f6-2a5c-71fc-a0dd-2d5ed91342b3",
        "storage_key": "property/5638944016302080/019e89f6-2a5c-71fc-a0dd-2d5ed91342b3.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy outdoor living with our sparkling swimming pool and convenient grilling stations, perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and built-in grills.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e5e3add5-f14d-47a5-aae6-6188b34f3023",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019e89f6-2795-77e0-8be7-917f14a0f12a.webp",
      "image_media": {
        "alt_text": "The Elliott Premier Apartment Homes monument sign with landscaping.",
        "public_id": "019e89f6-2795-77e0-8be7-917f14a0f12a",
        "storage_key": "property/5638944016302080/019e89f6-2795-77e0-8be7-917f14a0f12a.webp",
        "width": 2152,
        "height": 1434
      },
      "title": "Community",
      "description": "Welcome to The Elliott Premier Apartment Homes, a beautiful community with pristine landscaping and a welcoming monument sign.",
      "link": "",
      "alt_text": "The Elliott Premier Apartment Homes monument sign with landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_7ddef4bc14593b3be833827b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "THE SMOKE PIT",
      "poi_type": "Restaurants",
      "poi_address": "796 Concord Pkwy N, Concord, NC 28027, USA",
      "poi_short_description": "Country-style eatery serving BBQ ribs, brisket & pulled pork, plus wings & Southern sides.",
      "poi_long_description": "Country-style eatery serving BBQ ribs, brisket & pulled pork, plus wings & Southern sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f3-fc3a-743b-9b2b-b772b98e610c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f3-fc3a-743b-9b2b-b772b98e610c",
        "storage_key": "property/5638944016302080/019f14f3-fc3a-743b-9b2b-b772b98e610c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.thesmokepitonline.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17945924787614833162&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-smoke-pit",
      "poi_latitude": "35.4219585",
      "poi_longitude": "-80.6146521",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-795-7573",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7604-7524-9794-69bcc93eba67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7604-7524-9794-69bcc93eba67",
        "storage_key": "property/5638944016302080/019d02ef-7604-7524-9794-69bcc93eba67.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJwh9SXQPVIgRCtqoQ4O7DPk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_684d5770b35df30b6579f850",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Gianni's Trattoria",
      "poi_type": "Restaurants",
      "poi_address": "325 McGill Ave NW, Concord, NC 28027, USA",
      "poi_short_description": "Italian cuisine served in earthy, polished white-tablecloth setting with multiple seating options.",
      "poi_long_description": "Italian cuisine served in earthy, polished white-tablecloth setting with multiple seating options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-b649-737a-a61f-06d59cf2853f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-b649-737a-a61f-06d59cf2853f",
        "storage_key": "property/5638944016302080/019f14f6-b649-737a-a61f-06d59cf2853f.webp",
        "width": 1280,
        "height": 710
      },
      "poi_business_url": "http://giannistrattoria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11224949633022275117&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "giannis-trattoria",
      "poi_latitude": "35.415043",
      "poi_longitude": "-80.6039181",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 704-788-0595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7604-7524-9794-69bcc93eba67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7604-7524-9794-69bcc93eba67",
        "storage_key": "property/5638944016302080/019d02ef-7604-7524-9794-69bcc93eba67.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZyRXN1EOVIgRLa7xCTgIx5s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_7eaf94ea1f289f9d37775a8a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Cabarrus Brewing Company",
      "poi_type": "Restaurants",
      "poi_address": "329 McGill Ave NW, Concord, NC 28027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-b9e2-77e4-80af-7d6d31438c9a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-b9e2-77e4-80af-7d6d31438c9a",
        "storage_key": "property/5638944016302080/019f14f6-b9e2-77e4-80af-7d6d31438c9a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.cabarrusbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11885064815298070648&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cabarrus-brewing-company",
      "poi_latitude": "35.413838",
      "poi_longitude": "-80.603039",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 704-490-4487",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-79bb-7689-bf18-ed8b5b78c9dd",
        "storage_key": "property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy5b97KYPVIgReMhV0Ho78KQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "ec_40d8a01d4bfa2f7306ebc7cf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "High Branch Brewing Co.",
      "poi_type": "Restaurants",
      "poi_address": "305 McGill Ave NW #100, Concord, NC 28027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-b464-76fb-af6c-8bbe6652efcd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-b464-76fb-af6c-8bbe6652efcd",
        "storage_key": "property/5638944016302080/019f14f6-b464-76fb-af6c-8bbe6652efcd.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://highbranchbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1278762040292134598&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "high-branch-brewing-co",
      "poi_latitude": "35.4139639",
      "poi_longitude": "-80.6019948",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 704-706-3807",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-79bb-7689-bf18-ed8b5b78c9dd",
        "storage_key": "property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdYvD_KYPVIgRxs7d60wTvxE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "ec_1db777413196987ba8bf609f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Havana Carolina Restaurant & Bar",
      "poi_type": "Restaurants",
      "poi_address": "11 Union St S Suite, 108, Concord, NC 28025, USA",
      "poi_short_description": "Cozy setting for Cuban coffee, sandwiches, entrees & sides plus flan or tres leches for dessert.",
      "poi_long_description": "Cozy setting for Cuban coffee, sandwiches, entrees & sides plus flan or tres leches for dessert.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-bc8b-7202-b4d5-aefcac6d3be4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-bc8b-7202-b4d5-aefcac6d3be4",
        "storage_key": "property/5638944016302080/019f14f6-bc8b-7202-b4d5-aefcac6d3be4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://havanacarolina.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=577136187536674204&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "havana-carolina-restaurant--bar",
      "poi_latitude": "35.4104943",
      "poi_longitude": "-80.5807749",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 704-793-4233",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7604-7524-9794-69bcc93eba67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7604-7524-9794-69bcc93eba67",
        "storage_key": "property/5638944016302080/019d02ef-7604-7524-9794-69bcc93eba67.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8VzTSFEOVIgRnI0lBU5mAgg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cuban_restaurant"
    },
    {
      "id": "ec_b4ebaeaa669b1ec017849651",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "The Percantile and Creamery",
      "poi_type": "Restaurants",
      "poi_address": "8635 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Ice cream, muffins and coffee shop offering lattes, shakes and other treats.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-b6c3-7790-88eb-54c1e10862bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-b6c3-7790-88eb-54c1e10862bb",
        "storage_key": "property/5638944016302080/019f14f6-b6c3-7790-88eb-54c1e10862bb.webp",
        "width": 1024,
        "height": 691
      },
      "poi_business_url": "https://thepercantileandcreamery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7234705656763530391&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-percantile-and-creamery",
      "poi_latitude": "35.3734013",
      "poi_longitude": "-80.7276921",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 980-299-6969",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f7-2ab4-7763-b777-369f5bc8c936.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f7-2ab4-7763-b777-369f5bc8c936",
        "storage_key": "property/5638944016302080/019f14f7-2ab4-7763-b777-369f5bc8c936.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJvcImWK8cVIgRlzzmtXbWZmQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_261cbf92c3ea9502f20de950",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Waterbean Coffee",
      "poi_type": "Restaurants",
      "poi_address": "5501 Poplar Tent Rd, Concord, NC 28027, USA",
      "poi_short_description": "Cozy coffee shop chain serving breakfast, bagels, and sandwiches in a modern space.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-c0e9-77cf-b45a-ff6067d7c1d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-c0e9-77cf-b45a-ff6067d7c1d8",
        "storage_key": "property/5638944016302080/019f14f6-c0e9-77cf-b45a-ff6067d7c1d8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.waterbeancoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16702748801616158708&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "waterbean-coffee",
      "poi_latitude": "35.4110542",
      "poi_longitude": "-80.66825960000001",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-956-2555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f7-2ab4-7763-b777-369f5bc8c936.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f7-2ab4-7763-b777-369f5bc8c936",
        "storage_key": "property/5638944016302080/019f14f7-2ab4-7763-b777-369f5bc8c936.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJd2U0NT0FVIgR9J_pRIoVzOc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_a85c2e7ab77356bf673fe1e4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Pippa's Cafe",
      "poi_type": "Restaurants",
      "poi_address": "10040 Edison Square Dr NW, Concord, NC 28027, USA",
      "poi_short_description": "Steaks & classic pub fare in a relaxed space with a patio, full bar & TVs in every booth.",
      "poi_long_description": "Steaks & classic pub fare in a relaxed space with a patio, full bar & TVs in every booth.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-ba42-72f8-9805-f4a9d1c05b9c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-ba42-72f8-9805-f4a9d1c05b9c",
        "storage_key": "property/5638944016302080/019f14f6-ba42-72f8-9805-f4a9d1c05b9c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.pippascafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2360521741180729761&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pippas-cafe",
      "poi_latitude": "35.402407",
      "poi_longitude": "-80.7595044",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 704-948-1818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7604-7524-9794-69bcc93eba67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7604-7524-9794-69bcc93eba67",
        "storage_key": "property/5638944016302080/019d02ef-7604-7524-9794-69bcc93eba67.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ79c6HyQDVIgRofmpWwRCwiA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_48a6ff68f309c5bca622153c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Lil Papi's International Deli",
      "poi_type": "Restaurants",
      "poi_address": "1096 Concord Pkwy N #7, Concord, NC 28027, USA",
      "poi_short_description": "Friendly deli featuring sandwiches with various sauces served on fresh bread, as well as salads.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-bca9-7442-8be9-d1fdd33c4b05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-bca9-7442-8be9-d1fdd33c4b05",
        "storage_key": "property/5638944016302080/019f14f6-bca9-7442-8be9-d1fdd33c4b05.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.lilpapis.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3305187775907233193&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lil-papis-international-deli",
      "poi_latitude": "35.4291999",
      "poi_longitude": "-80.60788",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 980-781-5055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-75ff-7364-b4e6-35bc82f5216e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-75ff-7364-b4e6-35bc82f5216e",
        "storage_key": "property/5638944016302080/019d02ef-75ff-7364-b4e6-35bc82f5216e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ3QydC1cPVIgRqf3pQsVi3i0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "deli"
    },
    {
      "id": "ec_81687372d2a68531865bb27e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "BJ's Restaurant & Brewhouse",
      "poi_type": "Restaurants",
      "poi_address": "Parking lot, 8435 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Family-friendly chain outpost pairs familiar pub fare with an extensive list of house brews.",
      "poi_long_description": "Family-friendly chain outpost pairs familiar pub fare with an extensive list of house brews.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-b013-70c3-b2d8-fc447b2a0c2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-b013-70c3-b2d8-fc447b2a0c2f",
        "storage_key": "property/5638944016302080/019f14f6-b013-70c3-b2d8-fc447b2a0c2f.webp",
        "width": 800,
        "height": 600
      },
      "poi_business_url": "https://www.bjsrestaurants.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17878522490247606685&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bjs-restaurant--brewhouse",
      "poi_latitude": "35.3702706",
      "poi_longitude": "-80.7210994",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 980-777-7030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7604-7524-9794-69bcc93eba67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7604-7524-9794-69bcc93eba67",
        "storage_key": "property/5638944016302080/019d02ef-7604-7524-9794-69bcc93eba67.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLW9LrCYbVIgRnXEK_HpFHfg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_898ca70eed7f61b57c93e811",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Bad Daddy's Burger Bar",
      "poi_type": "Restaurants",
      "poi_address": "8915 Christenbury Pkwy Ste 70, Concord, NC 28027, USA",
      "poi_short_description": "Relaxed burger spot with an extensive beer list.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-c272-7718-b9c9-e1704b3ee4af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-c272-7718-b9c9-e1704b3ee4af",
        "storage_key": "property/5638944016302080/019f14f6-c272-7718-b9c9-e1704b3ee4af.webp",
        "width": 1280,
        "height": 914
      },
      "poi_business_url": "https://www.baddaddysburgerbar.com/locations/bad-daddys-burger-bar-22",
      "poi_directions_map_url": "https://maps.google.com/?cid=1501001344272918167&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bad-daddys-burger-bar",
      "poi_latitude": "35.3755277",
      "poi_longitude": "-80.73361090000002",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 980-430-5101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7604-7524-9794-69bcc93eba67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7604-7524-9794-69bcc93eba67",
        "storage_key": "property/5638944016302080/019d02ef-7604-7524-9794-69bcc93eba67.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJz91fc6wcVIgRl2bFHMWg1BQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "ec_6e5e4c31d81522f46686e3b3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Jim 'N Nick's Bar-B-Q",
      "poi_type": "Restaurants",
      "poi_address": "7791 Gateway Ln NW, Concord, NC 28027, USA",
      "poi_short_description": "Laid-back chain known for slow-cooked BBQ & cheese biscuits, plus burgers, salads & classic sides.",
      "poi_long_description": "Laid-back chain known for slow-cooked BBQ & cheese biscuits, plus burgers, salads & classic sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-c07f-771f-a07e-1fc4b0dd994e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-c07f-771f-a07e-1fc4b0dd994e",
        "storage_key": "property/5638944016302080/019f14f6-c07f-771f-a07e-1fc4b0dd994e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.jimnnicks.com/locations/nc/concord/7791-gateway-ln-nw?utm_source=google&utm_medium=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=12562333026055216592&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jim-n-nicks-bar-b-q",
      "poi_latitude": "35.3683831",
      "poi_longitude": "-80.7119815",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 704-453-2791",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7604-7524-9794-69bcc93eba67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7604-7524-9794-69bcc93eba67",
        "storage_key": "property/5638944016302080/019d02ef-7604-7524-9794-69bcc93eba67.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJa52kFlsbVIgR0N0tQFRfVq4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_3e642265d7de01acb946b36f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Bonefish Grill",
      "poi_type": "Restaurants",
      "poi_address": "8503 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Contemporary grill chain offering a seafood-centric menu, plus steaks & cocktails.",
      "poi_long_description": "Contemporary grill chain offering a seafood-centric menu, plus steaks & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-dcb7-71dd-aed1-c5d6a5b65b35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-dcb7-71dd-aed1-c5d6a5b65b35",
        "storage_key": "property/5638944016302080/019f14f6-dcb7-71dd-aed1-c5d6a5b65b35.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.bonefishgrill.com/north-carolina/concord-mills/8503-concord-mills-blvd?y_source=1_MTU1MDI4NTktNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=14029914822914293643&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bonefish-grill",
      "poi_latitude": "35.3706205",
      "poi_longitude": "-80.7219071",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 704-208-3618",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7604-7524-9794-69bcc93eba67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7604-7524-9794-69bcc93eba67",
        "storage_key": "property/5638944016302080/019d02ef-7604-7524-9794-69bcc93eba67.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXaEK-accVIgRiz_LoDJFtMI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_20b97db34eecb35c14ba55c5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Biryani Pot Indian Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "8455 Pit Stop Ct NW #150, Concord, NC 28027, USA",
      "poi_short_description": "Hyderabadi-Indian chain serving biryani, tandoori fare & other traditional dishes in a warm space.",
      "poi_long_description": "Hyderabadi-Indian chain serving biryani, tandoori fare & other traditional dishes in a warm space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-cfb2-736c-9da2-749bce355615.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-cfb2-736c-9da2-749bce355615",
        "storage_key": "property/5638944016302080/019f14f6-cfb2-736c-9da2-749bce355615.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.biryanipotcharlotte.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3893120086663231856&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "biryani-pot-indian-grill--bar",
      "poi_latitude": "35.3745083",
      "poi_longitude": "-80.7255199",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 704-979-8533",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7604-7524-9794-69bcc93eba67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7604-7524-9794-69bcc93eba67",
        "storage_key": "property/5638944016302080/019d02ef-7604-7524-9794-69bcc93eba67.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq4jDJOsdVIgRcPl_mRckBzY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "ec_f668419c681e1b845f520eb5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Sakura Sushi",
      "poi_type": "Restaurants",
      "poi_address": "8455 Pit Stop Ct NW #105, Concord, NC 28027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-cf01-735b-8526-1003449e9566.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-cf01-735b-8526-1003449e9566",
        "storage_key": "property/5638944016302080/019f14f6-cf01-735b-8526-1003449e9566.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://order.sakurasushiconcord.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16929512776105779469&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sakura-sushi",
      "poi_latitude": "35.3746343",
      "poi_longitude": "-80.7257751",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 704-456-7488",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7604-7524-9794-69bcc93eba67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7604-7524-9794-69bcc93eba67",
        "storage_key": "property/5638944016302080/019d02ef-7604-7524-9794-69bcc93eba67.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlUnOtyodVIgRDeE4aCy28eo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_4d84c7f5fe8fd8324c2ac59b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Food Lion",
      "poi_type": "Shopping & Retail",
      "poi_address": "547 Winecoff School Rd, Concord, NC 28027, USA",
      "poi_short_description": "Familiar grocery store offering organic produce and meats, plus self-checkout lanes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-cdbc-757f-b69c-17f0a9be7278.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-cdbc-757f-b69c-17f0a9be7278",
        "storage_key": "property/5638944016302080/019f14f6-cdbc-757f-b69c-17f0a9be7278.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.foodlion.com/nc/concord/547-winecoff-school-rd?y_source=1_NTA0NzAwNC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12082997061632484237&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "food-lion",
      "poi_latitude": "35.4432451",
      "poi_longitude": "-80.623633",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-795-2516",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-75fa-720a-9029-1a6254b256c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-75fa-720a-9029-1a6254b256c6",
        "storage_key": "property/5638944016302080/019d02ef-75fa-720a-9029-1a6254b256c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj4ywqV0PVIgRjWOxIM9tr6c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_31f1d52818f633dc9c83dbc6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "3905 Concord Pkwy S, Concord, NC 28027, USA",
      "poi_short_description": "Discount grocery store with a pharmacy, bakery, and deli, as well as self-checkout.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-d7e6-70bd-8728-0f7557813586.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-d7e6-70bd-8728-0f7557813586",
        "storage_key": "property/5638944016302080/019f14f6-d7e6-70bd-8728-0f7557813586.webp",
        "width": 1280,
        "height": 882
      },
      "poi_business_url": "https://www.walmart.com/store/6586-concord-nc/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=17284126847946917756&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "35.3665579",
      "poi_longitude": "-80.66589750000001",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 704-706-6045",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-75fa-720a-9029-1a6254b256c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-75fa-720a-9029-1a6254b256c6",
        "storage_key": "property/5638944016302080/019d02ef-75fa-720a-9029-1a6254b256c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9wU_MsUaVIgRfAerAMuN3e8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_cc02955dbd43e6e258cef2a0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Lowes Foods of Concord",
      "poi_type": "Shopping & Retail",
      "poi_address": "2415 Herrons Nest Pl NW, Concord, NC 28027, USA",
      "poi_short_description": "Supermarket chain known for chicken prepared on-site, plus pantry staples, produce, bakery & more.",
      "poi_long_description": "Supermarket chain known for chicken prepared on-site, plus pantry staples, produce, bakery & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-ce97-757e-b887-e3bd8c2d4e3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-ce97-757e-b887-e3bd8c2d4e3d",
        "storage_key": "property/5638944016302080/019f14f6-ce97-757e-b887-e3bd8c2d4e3d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.lowesfoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8054174508725485783&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lowes-foods-of-concord",
      "poi_latitude": "35.3799249",
      "poi_longitude": "-80.73553369999999",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 980-399-2093",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-75fa-720a-9029-1a6254b256c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-75fa-720a-9029-1a6254b256c6",
        "storage_key": "property/5638944016302080/019d02ef-75fa-720a-9029-1a6254b256c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD-zfAyodVIgR18CW9wotxm8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_35fdfacebdc998caadda37ff",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "5825 Thunder Rd NW, Concord, NC 28027, USA",
      "poi_short_description": "Department store offering grocery items, electronics, home goods and clothing along with a self checkout.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-d64c-711a-8fc0-4f0197f5708e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-d64c-711a-8fc0-4f0197f5708e",
        "storage_key": "property/5638944016302080/019f14f6-d64c-711a-8fc0-4f0197f5708e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/4574-concord-nc/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=7627622230872196852&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.3786689",
      "poi_longitude": "-80.7247333",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 704-979-2540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-75ff-7364-b4e6-35bc82f5216e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-75ff-7364-b4e6-35bc82f5216e",
        "storage_key": "property/5638944016302080/019d02ef-75ff-7364-b4e6-35bc82f5216e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8xdDfKkcVIgR9IYCkAHC2mk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_2ff8fca6c75380ddf8e7db1e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "6150 Bayfield Pkwy, Concord, NC 28027, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-d46b-777d-8e0b-c8fe40aa154e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-d46b-777d-8e0b-c8fe40aa154e",
        "storage_key": "property/5638944016302080/019f14f6-d46b-777d-8e0b-c8fe40aa154e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/kannapolis/2169",
      "poi_directions_map_url": "https://maps.google.com/?cid=8242760289763067225&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "35.4169437",
      "poi_longitude": "-80.6793321",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-262-6080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-75ff-7364-b4e6-35bc82f5216e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-75ff-7364-b4e6-35bc82f5216e",
        "storage_key": "property/5638944016302080/019d02ef-75ff-7364-b4e6-35bc82f5216e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJP0QovP0EVIgRWQUGwM8qZHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_2547ef4cbd9220aad0582c77",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "5225 Poplar Tent Rd, Concord, NC 28027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-d58b-7210-8109-ff9973c90347.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-d58b-7210-8109-ff9973c90347",
        "storage_key": "property/5638944016302080/019f14f6-d58b-7210-8109-ff9973c90347.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/concord-nc-pharmacies/5225-poplar-tent-rd-concord-nc-28027/storeid=2749?WT.mc_id=LS_GOOGLE_RX_2749",
      "poi_directions_map_url": "https://maps.google.com/?cid=6733660780212185043&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "35.4123186",
      "poi_longitude": "-80.66507170000001",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-782-1727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f7-2acf-73ac-974c-df759ecbc8a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f7-2acf-73ac-974c-df759ecbc8a5",
        "storage_key": "property/5638944016302080/019f14f7-2acf-73ac-974c-df759ecbc8a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVwJC5A8FVIgR0-eGms3Ecl0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_04559b07dea0b57b4d86de27",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "735 Cabarrus Ave W, Concord, NC 28027, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-da9d-75c8-a61f-0f6f20758c28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-da9d-75c8-a61f-0f6f20758c28",
        "storage_key": "property/5638944016302080/019f14f6-da9d-75c8-a61f-0f6f20758c28.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-735+cabarrus+ave+w-concord-nc-28027/id=4870",
      "poi_directions_map_url": "https://maps.google.com/?cid=12108311004864776823&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "35.3956621",
      "poi_longitude": "-80.60737069999999",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 704-723-9463",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-79bb-7689-bf18-ed8b5b78c9dd",
        "storage_key": "property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3TYmicAPVIgRdwrr0rRcCag",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_e61b59cf7fa1afe4b6600616",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "QuikTrip",
      "poi_type": "Shopping & Retail",
      "poi_address": "383 George W Liles Pkwy, Concord, NC 28027, USA",
      "poi_short_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_long_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-ddbf-7076-8173-aba0b8b8080c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-ddbf-7076-8173-aba0b8b8080c",
        "storage_key": "property/5638944016302080/019f14f6-ddbf-7076-8173-aba0b8b8080c.webp",
        "width": 600,
        "height": 339
      },
      "poi_business_url": "https://locations.quiktrip.com/nc/concord/383-george-liles-pkwy?utm_source=gmb&utm_medium=yext&y_source=1_MTYwMDQyODMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=2600086418002670202&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quiktrip",
      "poi_latitude": "35.4146336",
      "poi_longitude": "-80.6684113",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-782-0531",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f7-2ac0-7248-8579-b3dea7f5081f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f7-2ac0-7248-8579-b3dea7f5081f",
        "storage_key": "property/5638944016302080/019f14f7-2ac0-7248-8579-b3dea7f5081f.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5QwRBwUFVIgRevJdQtJcFSQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "ec_053ba36a36073cb9b03a948c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Mi Pais Latino Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "898 Concord Pkwy N, Concord, NC 28027, USA",
      "poi_short_description": "Grocery store with prepared foods and organic products located inside Northern Plaza.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-e599-73b6-a669-f2758ccbb29f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-e599-73b6-a669-f2758ccbb29f",
        "storage_key": "property/5638944016302080/019f14f6-e599-73b6-a669-f2758ccbb29f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1473162417292020989&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mi-pais-latino-market",
      "poi_latitude": "35.4240822",
      "poi_longitude": "-80.6148509",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-784-0035",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-75fa-720a-9029-1a6254b256c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-75fa-720a-9029-1a6254b256c6",
        "storage_key": "property/5638944016302080/019d02ef-75fa-720a-9029-1a6254b256c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLx3PwHMPVIgR_Ywl02m5cRQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_b76f5bac0016baf7da169f60",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Concord Mills",
      "poi_type": "Shopping & Retail",
      "poi_address": "8111 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Large mall with mostly outlet & big-box stores, plus a movie theater, restaurants & an aquarium.",
      "poi_long_description": "Large mall with mostly outlet & big-box stores, plus a movie theater, restaurants & an aquarium.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-e58e-70a9-aa00-bec3bd8346f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-e58e-70a9-aa00-bec3bd8346f8",
        "storage_key": "property/5638944016302080/019f14f6-e58e-70a9-aa00-bec3bd8346f8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.simon.com/mall/concord-mills",
      "poi_directions_map_url": "https://maps.google.com/?cid=15278858876011446672&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "concord-mills",
      "poi_latitude": "35.3690086",
      "poi_longitude": "-80.72197059999999",
      "poi_miles_from_property": "8.7 mi",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-886-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-75ff-7364-b4e6-35bc82f5216e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-75ff-7364-b4e6-35bc82f5216e",
        "storage_key": "property/5638944016302080/019d02ef-75ff-7364-b4e6-35bc82f5216e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJpU5jZKccVIgRkIH8ZTJpCdQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_ab938f81d1a21384342556e8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Northwest Cabarrus High School",
      "poi_type": "Education",
      "poi_address": "5130 NW Cabarrus Dr, Concord, NC 28027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-e167-7339-8a5c-34dc9b5a701a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-e167-7339-8a5c-34dc9b5a701a",
        "storage_key": "property/5638944016302080/019f14f6-e167-7339-8a5c-34dc9b5a701a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nwchs.cabarrus.k12.nc.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7199305199200749863&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-cabarrus-high-school",
      "poi_latitude": "35.4509169",
      "poi_longitude": "-80.6626081",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-260-6720",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7600-7341-ac5a-41f9c855b4a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7600-7341-ac5a-41f9c855b4a0",
        "storage_key": "property/5638944016302080/019d02ef-7600-7341-ac5a-41f9c855b4a0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEfcDWsQFVIgRJ8n7Y-8R6WM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_9af0b38487517579f9f38286",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Northwest Cabarrus Middle School",
      "poi_type": "Education",
      "poi_address": "5140 NW Cabarrus Dr, Concord, NC 28027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://nwcms.cabarrus.k12.nc.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8382255632537937636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-cabarrus-middle-school",
      "poi_latitude": "35.453104",
      "poi_longitude": "-80.6650435",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 704-260-6550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7600-7341-ac5a-41f9c855b4a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7600-7341-ac5a-41f9c855b4a0",
        "storage_key": "property/5638944016302080/019d02ef-7600-7341-ac5a-41f9c855b4a0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf_C_U8QFVIgR5ObwMRbBU3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_0451fb555b800219a2e7d166",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Charles E Boger Elementary",
      "poi_type": "Education",
      "poi_address": "5150 Dovefield Ln, Kannapolis, NC 28081, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-eb02-76aa-8878-0c42699d7ff3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-eb02-76aa-8878-0c42699d7ff3",
        "storage_key": "property/5638944016302080/019f14f6-eb02-76aa-8878-0c42699d7ff3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://cebes.cabarrus.k12.nc.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3586661491044098153&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charles-e-boger-elementary",
      "poi_latitude": "35.4550287",
      "poi_longitude": "-80.6618716",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-788-1600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7600-7341-ac5a-41f9c855b4a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7600-7341-ac5a-41f9c855b4a0",
        "storage_key": "property/5638944016302080/019d02ef-7600-7341-ac5a-41f9c855b4a0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIWTTJMUFVIgRaaBBh59hxjE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_0bcf325bff83c65375d484f9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "WR Odell Elementary",
      "poi_type": "Education",
      "poi_address": "1885 Odell School Rd, Concord, NC 28027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://wroes.cabarrus.k12.nc.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13962779731401583349&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wr-odell-elementary",
      "poi_latitude": "35.43851410000001",
      "poi_longitude": "-80.728729",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-260-6030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7600-7341-ac5a-41f9c855b4a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7600-7341-ac5a-41f9c855b4a0",
        "storage_key": "property/5638944016302080/019d02ef-7600-7341-ac5a-41f9c855b4a0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ88H_YY8DVIgR9So3DzDCxcE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_ccdc76d5ef569d85c1dadbf2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Pitts School Road Elementary",
      "poi_type": "Education",
      "poi_address": "720 Pitts School Rd SW, Concord, NC 28027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-e5ea-750b-90b0-eadca5bfc10c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-e5ea-750b-90b0-eadca5bfc10c",
        "storage_key": "property/5638944016302080/019f14f6-e5ea-750b-90b0-eadca5bfc10c.webp",
        "width": 597,
        "height": 394
      },
      "poi_business_url": "https://psres.cabarrus.k12.nc.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13821734115644837177&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pitts-school-road-elementary",
      "poi_latitude": "35.3433773",
      "poi_longitude": "-80.64639179999999",
      "poi_miles_from_property": "9.5 mi",
      "poi_walking_minutes": "3 hours 27 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 704-260-6250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7600-7341-ac5a-41f9c855b4a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7600-7341-ac5a-41f9c855b4a0",
        "storage_key": "property/5638944016302080/019d02ef-7600-7341-ac5a-41f9c855b4a0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZ8m2VY4aVIgROY3ojvKp0L8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_be72866cfc3c901989256538",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Cannon School",
      "poi_type": "Education",
      "poi_address": "5801 Poplar Tent Rd, Concord, NC 28027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-e7e1-7019-a663-1f4802f341bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-e7e1-7019-a663-1f4802f341bb",
        "storage_key": "property/5638944016302080/019f14f6-e7e1-7019-a663-1f4802f341bb.webp",
        "width": 433,
        "height": 433
      },
      "poi_business_url": "http://www.cannonschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17090633640608758889&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cannon-school",
      "poi_latitude": "35.4050993",
      "poi_longitude": "-80.6715059",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 704-786-8171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7600-7341-ac5a-41f9c855b4a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7600-7341-ac5a-41f9c855b4a0",
        "storage_key": "property/5638944016302080/019d02ef-7600-7341-ac5a-41f9c855b4a0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH632RhwFVIgRaXzT_r4gLu0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_6e93cc8451f83424478d93fb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Carolina International School",
      "poi_type": "Education",
      "poi_address": "C756+FP, 9545 Poplar Tent Rd, Concord, NC 28027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.ciscomets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6461202536746085167&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carolina-international-school",
      "poi_latitude": "35.4092833",
      "poi_longitude": "-80.7367372",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 704-455-3847",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7600-7341-ac5a-41f9c855b4a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7600-7341-ac5a-41f9c855b4a0",
        "storage_key": "property/5638944016302080/019d02ef-7600-7341-ac5a-41f9c855b4a0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJi_2DSjcfIRURL2uaaHnNqlk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_4f9d9f2c2eb02d12ae6ab882",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Rowan-Cabarrus Community College",
      "poi_type": "Education",
      "poi_address": "1531 Trinity Church Rd, Concord, NC 28027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f4-161b-7708-894b-39e0c6dbcf71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f4-161b-7708-894b-39e0c6dbcf71",
        "storage_key": "property/5638944016302080/019f14f4-161b-7708-894b-39e0c6dbcf71.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.rccc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14729629873731745231&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rowan-cabarrus-community-college",
      "poi_latitude": "35.4375622",
      "poi_longitude": "-80.659584",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 704-216-7222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7600-7341-ac5a-41f9c855b4a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7600-7341-ac5a-41f9c855b4a0",
        "storage_key": "property/5638944016302080/019d02ef-7600-7341-ac5a-41f9c855b4a0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ9fzD7wFVIgRzzXDSFQoasw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_0403f6a6b74351b862f9dc04",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Cabarrus College of Health Sciences",
      "poi_type": "Education",
      "poi_address": "401 Medical Park Dr NE, Concord, NC 28025, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-e90c-74fe-bd5a-55b00beed94d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-e90c-74fe-bd5a-55b00beed94d",
        "storage_key": "property/5638944016302080/019f14f6-e90c-74fe-bd5a-55b00beed94d.webp",
        "width": 667,
        "height": 667
      },
      "poi_business_url": "https://cabarruscollege.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1386404138424524097&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cabarrus-college-of-health-sciences",
      "poi_latitude": "35.439955",
      "poi_longitude": "-80.60091150000001",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-403-1555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7600-7341-ac5a-41f9c855b4a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7600-7341-ac5a-41f9c855b4a0",
        "storage_key": "property/5638944016302080/019d02ef-7600-7341-ac5a-41f9c855b4a0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3xmozxcPVIgRQd3s6Td_PRM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_d05d906d872ef382de90ac87",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Kids 'R' Kids Learning Academy of Concord",
      "poi_type": "Education",
      "poi_address": "320 Coddle Market Dr NW, Concord, NC 28027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-e987-75df-8822-7586bfd90553.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-e987-75df-8822-7586bfd90553",
        "storage_key": "property/5638944016302080/019f14f6-e987-75df-8822-7586bfd90553.webp",
        "width": 989,
        "height": 1280
      },
      "poi_business_url": "http://www.krkconcord.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11600355235460296864&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kids-r-kids-learning-academy-of-concord",
      "poi_latitude": "35.4094547",
      "poi_longitude": "-80.6626035",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-795-5437",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7600-7341-ac5a-41f9c855b4a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7600-7341-ac5a-41f9c855b4a0",
        "storage_key": "property/5638944016302080/019d02ef-7600-7341-ac5a-41f9c855b4a0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJgZoeUxAFVIgRoDD0FaC9_KA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_49bd0d9bc6e92490c17ddb8b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Charlotte Motor Speedway",
      "poi_type": "Entertainment",
      "poi_address": "5555 Concord Pkwy S, Concord, NC 28027, USA",
      "poi_short_description": "Iconic NASCAR racetrack in a 95,000-seat stadium, with separate drag-racing & dirt tracks.",
      "poi_long_description": "Iconic NASCAR racetrack in a 95,000-seat stadium, with separate drag-racing & dirt tracks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-ed56-736e-a288-96e6aa61943e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-ed56-736e-a288-96e6aa61943e",
        "storage_key": "property/5638944016302080/019f14f6-ed56-736e-a288-96e6aa61943e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.charlottemotorspeedway.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3877864903075356639&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte-motor-speedway",
      "poi_latitude": "35.3526259",
      "poi_longitude": "-80.6856586",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 31 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 800-455-3267",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-79bb-7689-bf18-ed8b5b78c9dd",
        "storage_key": "property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi8sDiRsbVIgR39_CYpXx0DU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "race_course"
    },
    {
      "id": "ec_82ce62c1cd099083a6f9f7f7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Cabarrus Arena & Events Center",
      "poi_type": "Entertainment",
      "poi_address": "4751 State Hwy 49, Concord, NC 28025, USA",
      "poi_short_description": "Multiuse venue with a ballroom, an arena, exhibition halls, and an outdoor area for meetings and events.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-ec48-7076-8bfd-d92d1b7a1ee2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-ec48-7076-8bfd-d92d1b7a1ee2",
        "storage_key": "property/5638944016302080/019f14f6-ec48-7076-8bfd-d92d1b7a1ee2.webp",
        "width": 667,
        "height": 514
      },
      "poi_business_url": "http://www.cabarrusarena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16272311680851446342&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cabarrus-arena--events-center",
      "poi_latitude": "35.3890786",
      "poi_longitude": "-80.4990383",
      "poi_miles_from_property": "11.7 mi",
      "poi_walking_minutes": "4 hours 19 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 704-920-3976",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-79bb-7689-bf18-ed8b5b78c9dd",
        "storage_key": "property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOyehWXUNVIgRRgqXY0Ld0uE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "ec_67c434f84ada79318a7f6f52",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "AMC Concord Mills 24",
      "poi_type": "Entertainment",
      "poi_address": "8421 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Comfortable, clean screening rooms at the mall location of this popular theater chain.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-f01e-77ce-bd39-df4f9dca95cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-f01e-77ce-bd39-df4f9dca95cf",
        "storage_key": "property/5638944016302080/019f14f6-f01e-77ce-bd39-df4f9dca95cf.webp",
        "width": 1280,
        "height": 911
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/charlotte/amc-concord-mills-24?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=17290551946530007973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-concord-mills-24",
      "poi_latitude": "35.3703321",
      "poi_longitude": "-80.7260192",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 704-979-0200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f7-2ac1-75ed-b8f0-c67d706737a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f7-2ac1-75ed-b8f0-c67d706737a7",
        "storage_key": "property/5638944016302080/019f14f7-2ac1-75ed-b8f0-c67d706737a7.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJJeT6YqYcVIgRpStc12Jh9O8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_d45fc53c6fb5916d73efab82",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "SEA LIFE Charlotte-Concord",
      "poi_type": "Entertainment",
      "poi_address": "8111 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Family-friendly exhibits with a variety of sea creatures (most offer play areas & group packages).",
      "poi_long_description": "Family-friendly exhibits with a variety of sea creatures (most offer play areas & group packages).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-ed1f-756c-a5a6-02d1e727c4ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-ed1f-756c-a5a6-02d1e727c4ef",
        "storage_key": "property/5638944016302080/019f14f6-ed1f-756c-a5a6-02d1e727c4ef.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.visitsealife.com/charlotte-concord/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=7728186963408053643&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sea-life-charlotte-concord",
      "poi_latitude": "35.3692328",
      "poi_longitude": "-80.72510779999999",
      "poi_miles_from_property": "8.5 mi",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 704-456-1955",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-79bb-7689-bf18-ed8b5b78c9dd",
        "storage_key": "property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR0LDIaccVIgRi-W99xgJQGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "ec_1c804ea31518eb7730b309b9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "The LEGO® Store Concord Mills",
      "poi_type": "Entertainment",
      "poi_address": "8111 Concord Mills Boulevard #206, Concord, NC 28027, USA",
      "poi_short_description": "Retailer showcasing the brand's colorful building sets & bricks, plus figurines & toys.",
      "poi_long_description": "Retailer showcasing the brand's colorful building sets & bricks, plus figurines & toys.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-efbb-763f-a3b7-21c9370f1ac3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-efbb-763f-a3b7-21c9370f1ac3",
        "storage_key": "property/5638944016302080/019f14f6-efbb-763f-a3b7-21c9370f1ac3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lego.com/en-us/stores/stores/us/concord-mills/?cmp=REF-202601-GBP-755&y_source=1_MTY2ODY4NDAtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=11038908257792716997&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-lego-store-concord-mills",
      "poi_latitude": "35.37027",
      "poi_longitude": "-80.7240465",
      "poi_miles_from_property": "8.5 mi",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 980-356-3012",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-75ff-7364-b4e6-35bc82f5216e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-75ff-7364-b4e6-35bc82f5216e",
        "storage_key": "property/5638944016302080/019d02ef-75ff-7364-b4e6-35bc82f5216e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJizGc0lsbVIgRxXDc5ZIUMpk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "toy_store"
    },
    {
      "id": "ec_989576ee6f0d50b50d6c6433",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Dave & Buster's Concord",
      "poi_type": "Entertainment",
      "poi_address": "8361 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_long_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f4-24f1-70a9-844c-952d444b6c1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f4-24f1-70a9-844c-952d444b6c1d",
        "storage_key": "property/5638944016302080/019f14f4-24f1-70a9-844c-952d444b6c1d.webp",
        "width": 1280,
        "height": 864
      },
      "poi_business_url": "https://www.daveandbusters.com/us/en/about/locations/concord",
      "poi_directions_map_url": "https://maps.google.com/?cid=6729695864119554056&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dave--busters-concord",
      "poi_latitude": "35.3711585",
      "poi_longitude": "-80.72406240000001",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 704-979-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7604-7524-9794-69bcc93eba67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7604-7524-9794-69bcc93eba67",
        "storage_key": "property/5638944016302080/019d02ef-7604-7524-9794-69bcc93eba67.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP_zX36ccVIgRCPBCo7uuZF0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_0abfb8cc1d86557947951ea8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "iFLY Indoor Skydiving - Charlotte",
      "poi_type": "Entertainment",
      "poi_address": "7840 Lyles Ln NW, Concord, NC 28027, USA",
      "poi_short_description": "Chain facility for simulated skydiving with an indoor wind tunnel for flights and parties.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-eef6-768c-a35a-9e51b0ce369f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-eef6-768c-a35a-9e51b0ce369f",
        "storage_key": "property/5638944016302080/019f14f6-eef6-768c-a35a-9e51b0ce369f.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.iflyworld.com/charlotte/?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=14657549381427685251&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ifly-indoor-skydiving---charlotte",
      "poi_latitude": "35.366276",
      "poi_longitude": "-80.714287",
      "poi_miles_from_property": "8.5 mi",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 704-851-4359",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-79bb-7689-bf18-ed8b5b78c9dd",
        "storage_key": "property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDdEUzJkbVIgRg2e-3YATass",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "ec_9b0ce3cb8e19c5b7de9cff23",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "K1 Speed Concord",
      "poi_type": "Entertainment",
      "poi_address": "800 Derita Rd #K, Concord, NC 28027, USA",
      "poi_short_description": "Chain of indoor racing centers featuring electric go-karting for all skill levels, plus food.",
      "poi_long_description": "Chain of indoor racing centers featuring electric go-karting for all skill levels, plus food.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-f14c-719a-a7ed-e5177d045e9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-f14c-719a-a7ed-e5177d045e9e",
        "storage_key": "property/5638944016302080/019f14f6-f14c-719a-a7ed-e5177d045e9e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://k1speed.com/concord-location.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=14043036545227898395&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "k1-speed-concord",
      "poi_latitude": "35.4037384",
      "poi_longitude": "-80.71535",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-490-4771",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-79bb-7689-bf18-ed8b5b78c9dd",
        "storage_key": "property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT3ENhqAEVIgRGz4jrlXj4sI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_a83a6152808b7870b693e402",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Hendrick Motorsports Museum and Team Store",
      "poi_type": "Entertainment",
      "poi_address": "4325 Papa Joe Hendrick Blvd 5/9 Shop, Charlotte, NC 28262, USA",
      "poi_short_description": "Stock car–racing organization's history museum, with a shop selling merchandise.",
      "poi_long_description": "Stock car–racing organization's history museum, with a shop selling merchandise.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-f1bc-75bf-8b69-5d4d7c59a159.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-f1bc-75bf-8b69-5d4d7c59a159",
        "storage_key": "property/5638944016302080/019f14f6-f1bc-75bf-8b69-5d4d7c59a159.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://hendrickmotorsports.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5658054252756282292&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hendrick-motorsports-museum-and-team-store",
      "poi_latitude": "35.3570957",
      "poi_longitude": "-80.70470859999999",
      "poi_miles_from_property": "9.1 mi",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 877-467-4890",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-79b9-776b-92e4-da00bdeebc31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-79b9-776b-92e4-da00bdeebc31",
        "storage_key": "property/5638944016302080/019d02ef-79b9-776b-92e4-da00bdeebc31.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJrecFoW4bVIgRtCttf11yhU4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_de2574f7659111ab4baebcbe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Mustang Owner's Museum",
      "poi_type": "Entertainment",
      "poi_address": "4001 Dearborn Pl NW, Concord, NC 28027, USA",
      "poi_short_description": "A collection, featuring Mustangs, muscle cars, memorabilia and exhibits about Ford's iconic sports model.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f4-1038-7772-9c3b-bac8758ec321.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f4-1038-7772-9c3b-bac8758ec321",
        "storage_key": "property/5638944016302080/019f14f4-1038-7772-9c3b-bac8758ec321.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mustangownersmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4280425307018293527&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mustang-owners-museum",
      "poi_latitude": "35.3669221",
      "poi_longitude": "-80.671039",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 980-439-5653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-79b9-776b-92e4-da00bdeebc31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-79b9-776b-92e4-da00bdeebc31",
        "storage_key": "property/5638944016302080/019d02ef-79b9-776b-92e4-da00bdeebc31.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJJTKuydsaVIgRF_FqWCMgZzs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_361430da7e14e99b8b92a4f0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Atrium Health Cabarrus",
      "poi_type": "Health and Wellness",
      "poi_address": "920 Church St N, Concord, NC 28025, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-58a8-75f4-83f8-629d8bd31119.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ef-58a8-75f4-83f8-629d8bd31119",
        "storage_key": "property/5638944016302080/019d02ef-58a8-75f4-83f8-629d8bd31119.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://atriumhealth.org/locations/atrium-health-cabarrus?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=1622612822891421659&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-cabarrus",
      "poi_latitude": "35.4366428",
      "poi_longitude": "-80.6020008",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-403-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-79b7-708d-a485-65c490ff503e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-79b7-708d-a485-65c490ff503e",
        "storage_key": "property/5638944016302080/019d02ef-79b7-708d-a485-65c490ff503e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJeXV8txcPVIgR299v9MOthBY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_353417953491e7c58cff1a77",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "FastMed Urgent Care Concord",
      "poi_type": "Health and Wellness",
      "poi_address": "391 George W Liles Pkwy, Concord, NC 28027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-f9fe-71de-96c6-32430df54310.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-f9fe-71de-96c6-32430df54310",
        "storage_key": "property/5638944016302080/019f14f6-f9fe-71de-96c6-32430df54310.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.fastmed.com/urgent-care-centers/concord-nc-walk-in-clinic",
      "poi_directions_map_url": "https://maps.google.com/?cid=15851876122857510594&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fastmed-urgent-care-concord",
      "poi_latitude": "35.4163001",
      "poi_longitude": "-80.6696094",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-886-1780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-79bb-7689-bf18-ed8b5b78c9dd",
        "storage_key": "property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ11eMRwQFVIgRwhZrzlgt_ds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_8f0d2484665cb9b2463e75a2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Atrium Health Primary Care Cabarrus Family Medicine",
      "poi_type": "Health and Wellness",
      "poi_address": "5641 Poplar Tent Rd #101, Concord, NC 28027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-f614-742c-91bf-a0ddb95d2af1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-f614-742c-91bf-a0ddb95d2af1",
        "storage_key": "property/5638944016302080/019f14f6-f614-742c-91bf-a0ddb95d2af1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://atriumhealth.org/locations/detail/atrium-health-primary-care-cabarrus-family-medicine-poplar-tent?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=11648510920795678082&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-primary-care-cabarrus-family-medicine",
      "poi_latitude": "35.4085436",
      "poi_longitude": "-80.6727006",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-782-1955",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-79bb-7689-bf18-ed8b5b78c9dd",
        "storage_key": "property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLXKTavEFVIgRguVITPfSp6E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "doctor"
    },
    {
      "id": "ec_0655f0e5770768f42deae80b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "5225 Poplar Tent Rd, Concord, NC 28027, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-f7fe-74b8-ba41-87213ae1d22d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-f7fe-74b8-ba41-87213ae1d22d",
        "storage_key": "property/5638944016302080/019f14f6-f7fe-74b8-ba41-87213ae1d22d.webp",
        "width": 1280,
        "height": 688
      },
      "poi_business_url": "https://www.cvs.com/store-locator/concord-nc-pharmacies/5225-poplar-tent-rd-concord-nc-28027/storeid=2749?WT.mc_id=LS_GOOGLE_FS_2749",
      "poi_directions_map_url": "https://maps.google.com/?cid=10066997486937818205&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "35.4123186",
      "poi_longitude": "-80.66507170000001",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-782-1727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-79bb-7689-bf18-ed8b5b78c9dd",
        "storage_key": "property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi7Fw5A8FVIgRXcSti-AotYs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_425522beb6063966b3fb5312",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "3905 Concord Pkwy S, Concord, NC 28027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-f5cf-746e-8107-820d771eda61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-f5cf-746e-8107-820d771eda61",
        "storage_key": "property/5638944016302080/019f14f6-f5cf-746e-8107-820d771eda61.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/6586-concord-nc/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=5145831537913186012&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "35.3665579",
      "poi_longitude": "-80.66589750000001",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 704-706-6046",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f7-2acf-73ac-974c-df759ecbc8a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f7-2acf-73ac-974c-df759ecbc8a5",
        "storage_key": "property/5638944016302080/019f14f7-2acf-73ac-974c-df759ecbc8a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9wU_MsUaVIgR3EZRG4WqaUc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_2078d909273efd5cbab0f093",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "735 Cabarrus Ave W, Concord, NC 28027, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-da9d-75c8-a61f-0f6f20758c28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-da9d-75c8-a61f-0f6f20758c28",
        "storage_key": "property/5638944016302080/019f14f6-da9d-75c8-a61f-0f6f20758c28.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-735+cabarrus+ave+w-concord-nc-28027/id=4870",
      "poi_directions_map_url": "https://maps.google.com/?cid=12108311004864776823&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "35.3956621",
      "poi_longitude": "-80.60737069999999",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 704-723-9463",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-79bb-7689-bf18-ed8b5b78c9dd",
        "storage_key": "property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3TYmicAPVIgRdwrr0rRcCag",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_d703b3d145ad667e5b3d9bf4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "180 Concord Commons Pl SW, Concord, NC 28027, USA",
      "poi_short_description": "Members-only gym with tanning and spa services, plus massage chairs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f4-18d6-7454-b3a0-a9e4d77451b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f4-18d6-7454-b3a0-a9e4d77451b4",
        "storage_key": "property/5638944016302080/019f14f4-18d6-7454-b3a0-a9e4d77451b4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/concord-nc?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=10222409241722086433&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.3896444",
      "poi_longitude": "-80.6210693",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 704-786-4050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-79bb-7689-bf18-ed8b5b78c9dd",
        "storage_key": "property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC5ouB_EPVIgRIeSDcQtL3Y0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_9ffddd7efb10d8e2c4fa9998",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Burn Boot Camp",
      "poi_type": "Health and Wellness",
      "poi_address": "350 George W Liles Pkwy, Concord, NC 28027, USA",
      "poi_short_description": "Friendly fitness program specializing in 45-minute workouts for all levels, plus childcare.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-f78f-76c8-aff5-b88f23f64170.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-f78f-76c8-aff5-b88f23f64170",
        "storage_key": "property/5638944016302080/019f14f6-f78f-76c8-aff5-b88f23f64170.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.burnbootcamp.com/locations/concord-nc/?utm_source=gmb&utm_medium=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=12880211758453011676&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burn-boot-camp",
      "poi_latitude": "35.4111318",
      "poi_longitude": "-80.6640397",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 828-372-2876",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-79bb-7689-bf18-ed8b5b78c9dd",
        "storage_key": "property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvbbwLRAFVIgR3LRmHlq0v7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_4394f5eba7107d33a52f2193",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Charlotte Family Yoga Center",
      "poi_type": "Health and Wellness",
      "poi_address": "8230 Poplar Tent Rd #104, Concord, NC 28027, USA",
      "poi_short_description": "Community-driven venue for daily classes, workshops and private lessons in hot and non-heated styles.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-fa5b-7191-a777-edc60b9bcac4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-fa5b-7191-a777-edc60b9bcac4",
        "storage_key": "property/5638944016302080/019f14f6-fa5b-7191-a777-edc60b9bcac4.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "http://www.charlottefamilyyoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11788907862096106592&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte-family-yoga-center",
      "poi_latitude": "35.409085",
      "poi_longitude": "-80.714945",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-992-1145",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7600-7341-ac5a-41f9c855b4a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7600-7341-ac5a-41f9c855b4a0",
        "storage_key": "property/5638944016302080/019d02ef-7600-7341-ac5a-41f9c855b4a0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGW2nPBUdVIgRYFQMgj2dmqM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_0ea33e8998364bc9818a8649",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "9Round Afton Village",
      "poi_type": "Health and Wellness",
      "poi_address": "5415 Village Dr NW, Concord, NC 28027, USA",
      "poi_short_description": "Fitness gym that challenges members with a different set of exercises for each 30-minute workout.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-fb75-754e-a2b5-a2bbeb90a54a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-fb75-754e-a2b5-a2bbeb90a54a",
        "storage_key": "property/5638944016302080/019f14f6-fb75-754e-a2b5-a2bbeb90a54a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.9round.com/ConcordNCAftonVillage",
      "poi_directions_map_url": "https://maps.google.com/?cid=2371980387888456540&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "9round-afton-village",
      "poi_latitude": "35.4141223",
      "poi_longitude": "-80.67020740000001",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-467-8970",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-79bb-7689-bf18-ed8b5b78c9dd",
        "storage_key": "property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkxiEkwQFVIgRXONIcpj36iA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_501ad80ea6aef963efc9edb6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Frank Liske Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4001 Stough Rd, Concord, NC 28027, USA",
      "poi_short_description": "Popular recreation area with picnic pavilions, fishing & boating lake, athletic fields & mini-golf.",
      "poi_long_description": "Popular recreation area with picnic pavilions, fishing & boating lake, athletic fields & mini-golf.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f4-3ec1-75fe-86c7-6feef2edd678.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f4-3ec1-75fe-86c7-6feef2edd678",
        "storage_key": "property/5638944016302080/019f14f4-3ec1-75fe-86c7-6feef2edd678.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cabarruscounty.us/Parks/Frank-Liske-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2006933554194560920&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frank-liske-park",
      "poi_latitude": "35.361684",
      "poi_longitude": "-80.6182017",
      "poi_miles_from_property": "8.7 mi",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 704-920-2701",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7d1f-7719-b64d-28f8cd46e604.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7d1f-7719-b64d-28f8cd46e604",
        "storage_key": "property/5638944016302080/019d02ef-7d1f-7719-b64d-28f8cd46e604.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ177AMhAQVIgRmDeUMW8P2hs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_5c26a4616b5b93834e52f7c3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Vietnam Veterans Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "760 Orphanage Rd, Concord, NC 28027, USA",
      "poi_short_description": "Serene recreation area with a duck pond, disc-golf course, play areas, sport courts & picnic areas.",
      "poi_long_description": "Serene recreation area with a duck pond, disc-golf course, play areas, sport courts & picnic areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-61f7-7558-bd3d-ecfd1a11f119.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ef-61f7-7558-bd3d-ecfd1a11f119",
        "storage_key": "property/5638944016302080/019d02ef-61f7-7558-bd3d-ecfd1a11f119.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cabarruscounty.us/alp",
      "poi_directions_map_url": "https://maps.google.com/?cid=4064188024634341009&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vietnam-veterans-park",
      "poi_latitude": "35.4448957",
      "poi_longitude": "-80.63568819999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7d1f-7719-b64d-28f8cd46e604.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7d1f-7719-b64d-28f8cd46e604",
        "storage_key": "property/5638944016302080/019d02ef-7d1f-7719-b64d-28f8cd46e604.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0xI93vUFVIgRkfa5tHnlZjg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_99b94cafdf8f553ce885a182",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Dorton Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5790 Poplar Tent Rd, Concord, NC 28027, USA",
      "poi_short_description": "City park with a soccer field, tennis courts, a disc-golf course, play equipment & picnic shelters.",
      "poi_long_description": "City park with a soccer field, tennis courts, a disc-golf course, play equipment & picnic shelters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f4-4f91-72e8-8bde-33955544b15e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f4-4f91-72e8-8bde-33955544b15e",
        "storage_key": "property/5638944016302080/019f14f4-4f91-72e8-8bde-33955544b15e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.concordnc.gov/Departments/Parks-Recreation/Facilities",
      "poi_directions_map_url": "https://maps.google.com/?cid=3681378544137101712&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dorton-park",
      "poi_latitude": "35.4089823",
      "poi_longitude": "-80.6736243",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-920-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7d1f-7719-b64d-28f8cd46e604.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7d1f-7719-b64d-28f8cd46e604",
        "storage_key": "property/5638944016302080/019d02ef-7d1f-7719-b64d-28f8cd46e604.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJzavaRxwFVIgRkGEJ90fiFjM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_276a231e1b14f6c6d9380949",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Hector H. Henry II Greenway (The Mills At Rocky River)",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1095 Drake Mill Lane Southwest, Concord, NC 28025, USA",
      "poi_short_description": "Shady dirt path and greenway that runs along segments of the Rocky River, with wooden bridges.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-ff15-7317-9811-a76f08848f58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-ff15-7317-9811-a76f08848f58",
        "storage_key": "property/5638944016302080/019f14f6-ff15-7317-9811-a76f08848f58.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://concordnc.gov/Departments/Parks-Recreation/Greenways",
      "poi_directions_map_url": "https://maps.google.com/?cid=10631618061726848481&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hector-h-henry-ii-greenway-the-mills-at-rocky-river",
      "poi_latitude": "35.3154937",
      "poi_longitude": "-80.59297970000001",
      "poi_miles_from_property": "12.3 mi",
      "poi_walking_minutes": "4 hours 31 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7d1f-7719-b64d-28f8cd46e604.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7d1f-7719-b64d-28f8cd46e604",
        "storage_key": "property/5638944016302080/019d02ef-7d1f-7719-b64d-28f8cd46e604.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJPaye95ERVIgR4RXbZEwYi5M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_ddb5739ee617c10683c101f0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Les Myers Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "338 Lawndale Ave SE, Concord, NC 28025, USA",
      "poi_short_description": "Sizable park with a variety of play equipment, several tennis courts, ballfields & walking trails.",
      "poi_long_description": "Sizable park with a variety of play equipment, several tennis courts, ballfields & walking trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-fdd6-742e-96fb-c3dac50e6d02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-fdd6-742e-96fb-c3dac50e6d02",
        "storage_key": "property/5638944016302080/019f14f6-fdd6-742e-96fb-c3dac50e6d02.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.concordnc.gov/departments/parks-recreation/facilities",
      "poi_directions_map_url": "https://maps.google.com/?cid=13830480261806840833&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "les-myers-park",
      "poi_latitude": "35.3991201",
      "poi_longitude": "-80.5594314",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 704-920-5601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7d1f-7719-b64d-28f8cd46e604.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7d1f-7719-b64d-28f8cd46e604",
        "storage_key": "property/5638944016302080/019d02ef-7d1f-7719-b64d-28f8cd46e604.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Q5dkW4OVIgRAVwMZoW8778",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_c864a0320440c6a7ff1e8ff6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "J.W. (Mickey) McGee Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "219 Corban Ave SE, Concord, NC 28025, USA",
      "poi_short_description": "14-acre park offering a picnic pavilion, kids' play equipment, restrooms & a paved 1/4-mi. path.",
      "poi_long_description": "14-acre park offering a picnic pavilion, kids' play equipment, restrooms & a paved 1/4-mi. path.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f4-528e-734e-97a9-0f48f29ee822.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f4-528e-734e-97a9-0f48f29ee822",
        "storage_key": "property/5638944016302080/019f14f4-528e-734e-97a9-0f48f29ee822.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.concordnc.gov/Departments/Parks-Recreation/Facilities",
      "poi_directions_map_url": "https://maps.google.com/?cid=15613807780479550066&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jw-mickey-mcgee-park",
      "poi_latitude": "35.4109558",
      "poi_longitude": "-80.5695531",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 704-920-5601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7d1f-7719-b64d-28f8cd46e604.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7d1f-7719-b64d-28f8cd46e604",
        "storage_key": "property/5638944016302080/019d02ef-7d1f-7719-b64d-28f8cd46e604.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJIylbg14OVIgRcsK2anNjr9g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_540c3a1dad3794c2b7362f54",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "The Village Greenway Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "The Village Greenway, Concord, NC 28025, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f7-07f8-71bc-bf7f-4ff25b258f89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-07f8-71bc-bf7f-4ff25b258f89",
        "storage_key": "property/5638944016302080/019f14f7-07f8-71bc-bf7f-4ff25b258f89.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13452975057742013090&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-village-greenway-trailhead",
      "poi_latitude": "35.4089883",
      "poi_longitude": "-80.5922337",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 704-920-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7d1f-7719-b64d-28f8cd46e604.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7d1f-7719-b64d-28f8cd46e604",
        "storage_key": "property/5638944016302080/019d02ef-7d1f-7719-b64d-28f8cd46e604.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJf_lfsGUPVIgRoiLnwImRsro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_7c6d7b007c7977620a714536",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "W W Flowe Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "99 Central Heights Dr, Concord, NC 28025, USA",
      "poi_short_description": "Park containing a 4-field baseball & softball complex with restrooms, playground & picnic shelters.",
      "poi_long_description": "Park containing a 4-field baseball & softball complex with restrooms, playground & picnic shelters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f7-01a8-7113-894a-e7a2043d7d36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-01a8-7113-894a-e7a2043d7d36",
        "storage_key": "property/5638944016302080/019f14f7-01a8-7113-894a-e7a2043d7d36.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.concordnc.gov/Departments/Parks-Recreation/Facilities",
      "poi_directions_map_url": "https://maps.google.com/?cid=12999726006479262375&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "w-w-flowe-park",
      "poi_latitude": "35.3572906",
      "poi_longitude": "-80.5858001",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 35 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 704-262-3444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7d1f-7719-b64d-28f8cd46e604.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7d1f-7719-b64d-28f8cd46e604",
        "storage_key": "property/5638944016302080/019d02ef-7d1f-7719-b64d-28f8cd46e604.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3xPgNTMQVIgRp5Kaae1NaLQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_ad21529b6efdb95037243c88",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Weddington Road Bark Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8955 Weddington Rd, Concord, NC 28027, USA",
      "poi_short_description": "Bark park with separate spaces for small and large dogs and seating for dog owners.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f7-04e2-71e8-94e4-be2f2578efce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-04e2-71e8-94e4-be2f2578efce",
        "storage_key": "property/5638944016302080/019f14f7-04e2-71e8-94e4-be2f2578efce.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://concordnc.gov/Departments/Parks-Recreation/Parks#Bark%20Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16508994257811119300&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "weddington-road-bark-park",
      "poi_latitude": "35.3728237",
      "poi_longitude": "-80.7038773",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 704-920-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7d1f-7719-b64d-28f8cd46e604.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7d1f-7719-b64d-28f8cd46e604",
        "storage_key": "property/5638944016302080/019d02ef-7d1f-7719-b64d-28f8cd46e604.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJB5-4dTUbVIgRxJzLH8-6G-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "ec_7265ad3ceff2bb751f858838",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Baker's Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1275 W A St, Kannapolis, NC 28081, USA",
      "poi_short_description": "Recreational area featuring covered picnic tables, sports courts, a creek, playground & mini golf.",
      "poi_long_description": "Recreational area featuring covered picnic tables, sports courts, a creek, playground & mini golf.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f7-02df-707e-9271-cbe0f7c36ba6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-02df-707e-9271-cbe0f7c36ba6",
        "storage_key": "property/5638944016302080/019f14f7-02df-707e-9271-cbe0f7c36ba6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kannapolisnc.gov/government-departments/parks-recreation/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=9082697219787445595&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bakers-creek-park",
      "poi_latitude": "35.5098316",
      "poi_longitude": "-80.6326082",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 704-938-8512",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7d1f-7719-b64d-28f8cd46e604.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7d1f-7719-b64d-28f8cd46e604",
        "storage_key": "property/5638944016302080/019d02ef-7d1f-7719-b64d-28f8cd46e604.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJV5JEpHgIVIgRW9Xby_84DH4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_9415a96ccbaddc61c2f14b17",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Rider Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "45 Transit Ct NW, Concord, NC 28025, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f7-02e8-73a8-b26a-ff2eea0a79a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-02e8-73a8-b26a-ff2eea0a79a0",
        "storage_key": "property/5638944016302080/019f14f7-02e8-73a8-b26a-ff2eea0a79a0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ckrider.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15447285532781352266&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rider-transit-center",
      "poi_latitude": "35.4423245",
      "poi_longitude": "-80.60953130000001",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-920-7433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f7-2ad1-7714-8018-69d88c6fafb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f7-2ad1-7714-8018-69d88c6fafb4",
        "storage_key": "property/5638944016302080/019f14f7-2ad1-7714-8018-69d88c6fafb4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxzhcj1cOVIgRSpV2TVnIX9Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "ec_b525b5845b65edc575e912aa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Kannapolis Train Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "201 S Main St, Kannapolis, NC 28081, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-69e7-70e6-af14-50db03113721.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ef-69e7-70e6-af14-50db03113721",
        "storage_key": "property/5638944016302080/019d02ef-69e7-70e6-af14-50db03113721.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=KAN",
      "poi_directions_map_url": "https://maps.google.com/?cid=16553330046289025198&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kannapolis-train-station",
      "poi_latitude": "35.4961078",
      "poi_longitude": "-80.624883",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7dcb-74ed-b17b-62c397205742.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7dcb-74ed-b17b-62c397205742",
        "storage_key": "property/5638944016302080/019d02ef-7dcb-74ed-b17b-62c397205742.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ06xB0YQIVIgRrpjbSvk9ueU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_5b35aa765a43eafdf5614002",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Concord-Padgett Regional Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "9000 Aviation Blvd NW, Concord, NC 28027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f4-4ae6-744f-b40e-37a3a627a89f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f4-4ae6-744f-b40e-37a3a627a89f",
        "storage_key": "property/5638944016302080/019f14f4-4ae6-744f-b40e-37a3a627a89f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.concordairportnc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3225199722171956439&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "concord-padgett-regional-airport",
      "poi_latitude": "35.3804095",
      "poi_longitude": "-80.7141408",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 704-920-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7dcf-77f5-90a1-ad31a7f77aca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7dcf-77f5-90a1-ad31a7f77aca",
        "storage_key": "property/5638944016302080/019d02ef-7dcf-77f5-90a1-ad31a7f77aca.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJJS7J47EEVIgR13y_OQ82wiw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "ec_8667eae223b682e66d0c6e85",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Charlotte Douglas International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5501 Josh Birmingham Pkwy, Charlotte, NC 28208, USA",
      "poi_short_description": "Airport with rocking chairs, free WiFi & a 60-foot outdoor sculpture symbolizing flight.",
      "poi_long_description": "Airport with rocking chairs, free WiFi & a 60-foot outdoor sculpture symbolizing flight.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f7-0d72-7795-ae4c-5761f94def49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-0d72-7795-ae4c-5761f94def49",
        "storage_key": "property/5638944016302080/019f14f7-0d72-7795-ae4c-5761f94def49.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cltairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1925933632275654455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte-douglas-international-airport",
      "poi_latitude": "35.2162994",
      "poi_longitude": "-80.95394280000001",
      "poi_miles_from_property": "31.2 mi",
      "poi_walking_minutes": "11 hours 29 mins",
      "poi_biking_minutes": "2 hours 48 mins",
      "poi_driving_minutes": "36 mins",
      "poi_business_phone": "+1 704-359-4013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7dcf-77f5-90a1-ad31a7f77aca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7dcf-77f5-90a1-ad31a7f77aca",
        "storage_key": "property/5638944016302080/019d02ef-7dcf-77f5-90a1-ad31a7f77aca.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJidRKt32YVogRN6fEPG9Kuho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_7f4e2fab824b96e73f6a2ebe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Charlotte Motor Speedway",
      "poi_type": "Transportation & Transit",
      "poi_address": "5555 Concord Pkwy S, Concord, NC 28027, USA",
      "poi_short_description": "Iconic NASCAR racetrack in a 95,000-seat stadium, with separate drag-racing & dirt tracks.",
      "poi_long_description": "Iconic NASCAR racetrack in a 95,000-seat stadium, with separate drag-racing & dirt tracks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-ed56-736e-a288-96e6aa61943e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-ed56-736e-a288-96e6aa61943e",
        "storage_key": "property/5638944016302080/019f14f6-ed56-736e-a288-96e6aa61943e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.charlottemotorspeedway.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3877864903075356639&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte-motor-speedway",
      "poi_latitude": "35.3526259",
      "poi_longitude": "-80.6856586",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 31 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 800-455-3267",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-79bb-7689-bf18-ed8b5b78c9dd",
        "storage_key": "property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi8sDiRsbVIgR39_CYpXx0DU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "race_course"
    },
    {
      "id": "ec_e52f18922e06c8c9744d8878",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Concord Mills Mall",
      "poi_type": "Transportation & Transit",
      "poi_address": "Concord, NC 28027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f7-12d5-747a-838e-270de105dc5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-12d5-747a-838e-270de105dc5b",
        "storage_key": "property/5638944016302080/019f14f7-12d5-747a-838e-270de105dc5b.webp",
        "width": 1280,
        "height": 943
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3217386750302212418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "concord-mills-mall",
      "poi_latitude": "35.36957",
      "poi_longitude": "-80.72563",
      "poi_miles_from_property": "8.5 mi",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-79bb-7689-bf18-ed8b5b78c9dd",
        "storage_key": "property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjWn3fKYcVIgRQtHP9DN0piw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_d7de6d44eba3ce3fb6fc754e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "The Home Depot",
      "poi_type": "Transportation & Transit",
      "poi_address": "3313 Cloverleaf Plaza, Kannapolis, NC 28083, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-3297-716c-8406-df52113bb829.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ef-3297-716c-8406-df52113bb829",
        "storage_key": "property/5638944016302080/019d02ef-3297-716c-8406-df52113bb829.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/Kannapolis/NC/Kannapolis/28083/3607?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=5733231092479103064&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "35.4488281",
      "poi_longitude": "-80.60576999999999",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-786-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-75ff-7364-b4e6-35bc82f5216e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-75ff-7364-b4e6-35bc82f5216e",
        "storage_key": "property/5638944016302080/019d02ef-75ff-7364-b4e6-35bc82f5216e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ0VmZmjkPVIgRWBBxek2HkE8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "ec_0032d5e17e08e0431a152e51",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Atrium Health Cabarrus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "920 Church St N, Concord, NC 28025, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-58a8-75f4-83f8-629d8bd31119.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ef-58a8-75f4-83f8-629d8bd31119",
        "storage_key": "property/5638944016302080/019d02ef-58a8-75f4-83f8-629d8bd31119.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://atriumhealth.org/locations/atrium-health-cabarrus?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=1622612822891421659&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-cabarrus",
      "poi_latitude": "35.4366428",
      "poi_longitude": "-80.6020008",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-403-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-79b7-708d-a485-65c490ff503e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-79b7-708d-a485-65c490ff503e",
        "storage_key": "property/5638944016302080/019d02ef-79b7-708d-a485-65c490ff503e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJeXV8txcPVIgR299v9MOthBY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_11b8888b822296737ba7adef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Cabarrus College of Health Sciences",
      "poi_type": "Major Employers & Offices",
      "poi_address": "401 Medical Park Dr NE, Concord, NC 28025, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-e90c-74fe-bd5a-55b00beed94d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-e90c-74fe-bd5a-55b00beed94d",
        "storage_key": "property/5638944016302080/019f14f6-e90c-74fe-bd5a-55b00beed94d.webp",
        "width": 667,
        "height": 667
      },
      "poi_business_url": "https://cabarruscollege.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1386404138424524097&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cabarrus-college-of-health-sciences",
      "poi_latitude": "35.439955",
      "poi_longitude": "-80.60091150000001",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-403-1555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7600-7341-ac5a-41f9c855b4a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7600-7341-ac5a-41f9c855b4a0",
        "storage_key": "property/5638944016302080/019d02ef-7600-7341-ac5a-41f9c855b4a0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3xmozxcPVIgRQd3s6Td_PRM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_2c0ec15e193af73a3a189b53",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Cabarrus County Governmental Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "65 Church St S, Concord, NC 28025, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f7-19a9-758c-9dfa-39ede2d314ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-19a9-758c-9dfa-39ede2d314ef",
        "storage_key": "property/5638944016302080/019f14f7-19a9-758c-9dfa-39ede2d314ef.webp",
        "width": 1280,
        "height": 772
      },
      "poi_business_url": "http://www.cabarruscounty.us",
      "poi_directions_map_url": "https://maps.google.com/?cid=11349149599125686418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cabarrus-county-governmental-center",
      "poi_latitude": "35.410075",
      "poi_longitude": "-80.5783132",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 704-920-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f7-2ad1-7714-8018-69d88c6fafb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f7-2ad1-7714-8018-69d88c6fafb4",
        "storage_key": "property/5638944016302080/019f14f7-2ad1-7714-8018-69d88c6fafb4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn5BJsVAOVIgRkkinFm5HgJ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "ec_6f25973f2778d9a4dc2d1bee",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Cabarrus County Schools Administration",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4401 Old Airport Rd, Concord, NC 28025, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f7-16d0-76e9-bbe7-694bbfd36509.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-16d0-76e9-bbe7-694bbfd36509",
        "storage_key": "property/5638944016302080/019f14f7-16d0-76e9-bbe7-694bbfd36509.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.cabarrus.k12.nc.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2267630554600030713&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cabarrus-county-schools-administration",
      "poi_latitude": "35.3888825",
      "poi_longitude": "-80.50640299999999",
      "poi_miles_from_property": "11.5 mi",
      "poi_walking_minutes": "4 hours 14 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 704-260-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-7600-7341-ac5a-41f9c855b4a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-7600-7341-ac5a-41f9c855b4a0",
        "storage_key": "property/5638944016302080/019d02ef-7600-7341-ac5a-41f9c855b4a0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPYgQaqINVIgR-cHBmPk9eB8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_622f8d6a5b02bdbb0c5b927f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Charlotte Motor Speedway",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5555 Concord Pkwy S, Concord, NC 28027, USA",
      "poi_short_description": "Iconic NASCAR racetrack in a 95,000-seat stadium, with separate drag-racing & dirt tracks.",
      "poi_long_description": "Iconic NASCAR racetrack in a 95,000-seat stadium, with separate drag-racing & dirt tracks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-ed56-736e-a288-96e6aa61943e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-ed56-736e-a288-96e6aa61943e",
        "storage_key": "property/5638944016302080/019f14f6-ed56-736e-a288-96e6aa61943e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.charlottemotorspeedway.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3877864903075356639&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte-motor-speedway",
      "poi_latitude": "35.3526259",
      "poi_longitude": "-80.6856586",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 31 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 800-455-3267",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-79bb-7689-bf18-ed8b5b78c9dd",
        "storage_key": "property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi8sDiRsbVIgR39_CYpXx0DU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "race_course"
    },
    {
      "id": "ec_2f2ef836c740496354293f7d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "RFK Racing",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4202 Roush Pl, Concord, NC 28027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f7-15a8-773e-abe5-41cf444a6a85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-15a8-773e-abe5-41cf444a6a85",
        "storage_key": "property/5638944016302080/019f14f7-15a8-773e-abe5-41cf444a6a85.webp",
        "width": 600,
        "height": 338
      },
      "poi_business_url": "https://www.rfkracing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16914187880580830334&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rfk-racing",
      "poi_latitude": "35.3846549",
      "poi_longitude": "-80.71867259999999",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 704-720-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-75ff-7364-b4e6-35bc82f5216e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-75ff-7364-b4e6-35bc82f5216e",
        "storage_key": "property/5638944016302080/019d02ef-75ff-7364-b4e6-35bc82f5216e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJSznv3aoEVIgRftQ8HkNEu-o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "car_dealer"
    },
    {
      "id": "ec_f3032c1a3f2012cb958c0422",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Trackhouse Racing",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8500 Westmoreland Dr NW, Concord, NC 28027, USA",
      "poi_short_description": "Shop selling motorsports apparel and offering views of the shop.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f7-1b78-74ec-a1db-adea84a4ce0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-1b78-74ec-a1db-adea84a4ce0e",
        "storage_key": "property/5638944016302080/019f14f7-1b78-74ec-a1db-adea84a4ce0e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.trackhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10386447187393893647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trackhouse-racing",
      "poi_latitude": "35.4029012",
      "poi_longitude": "-80.71056589999999",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 704-660-7199",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-75ff-7364-b4e6-35bc82f5216e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-75ff-7364-b4e6-35bc82f5216e",
        "storage_key": "property/5638944016302080/019d02ef-75ff-7364-b4e6-35bc82f5216e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ56Hl0aIEVIgRD9X36q8SJJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "ec_b275bf901003ed5a1ebe0a62",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Westrock Coffee S&D coffee",
      "poi_type": "Major Employers & Offices",
      "poi_address": "300 Concord Pkwy S, Concord, NC 28027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f7-1e30-72a8-b8f4-fcccbd675ca9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-1e30-72a8-b8f4-fcccbd675ca9",
        "storage_key": "property/5638944016302080/019f14f7-1e30-72a8-b8f4-fcccbd675ca9.webp",
        "width": 1280,
        "height": 993
      },
      "poi_business_url": "http://westrockcoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5873572429895966420&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westrock-coffee-sd-coffee",
      "poi_latitude": "35.39643",
      "poi_longitude": "-80.614548",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 800-933-2210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-79bb-7689-bf18-ed8b5b78c9dd",
        "storage_key": "property/5638944016302080/019d02ef-79bb-7689-bf18-ed8b5b78c9dd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAeIjOOsPVIgR1B56ZgEfg1E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wholesaler"
    },
    {
      "id": "ec_56c00841788328e25444805c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Shoe Show Inc",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2201 Trinity Church Rd #3, Concord, NC 28027, USA",
      "poi_short_description": "Shoe store whose customers say good things about its people.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f7-215b-774d-b604-445d7df29d2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-215b-774d-b604-445d7df29d2c",
        "storage_key": "property/5638944016302080/019f14f7-215b-774d-b604-445d7df29d2c.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "http://www.shoedept.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14374988290054842297&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shoe-show-inc",
      "poi_latitude": "35.4443375",
      "poi_longitude": "-80.6637497",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 704-782-4143",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-75ff-7364-b4e6-35bc82f5216e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-75ff-7364-b4e6-35bc82f5216e",
        "storage_key": "property/5638944016302080/019d02ef-75ff-7364-b4e6-35bc82f5216e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJb9sXebgFVIgRuWceF7A3fsc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shoe_store"
    },
    {
      "id": "ec_0431243cdb806df86ceb6bc9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "generator",
      "poi_name": "Concord Mills",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8111 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Large mall with mostly outlet & big-box stores, plus a movie theater, restaurants & an aquarium.",
      "poi_long_description": "Large mall with mostly outlet & big-box stores, plus a movie theater, restaurants & an aquarium.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14f6-e58e-70a9-aa00-bec3bd8346f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-e58e-70a9-aa00-bec3bd8346f8",
        "storage_key": "property/5638944016302080/019f14f6-e58e-70a9-aa00-bec3bd8346f8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.simon.com/mall/concord-mills",
      "poi_directions_map_url": "https://maps.google.com/?cid=15278858876011446672&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "concord-mills",
      "poi_latitude": "35.3690086",
      "poi_longitude": "-80.72197059999999",
      "poi_miles_from_property": "8.7 mi",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-886-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-75ff-7364-b4e6-35bc82f5216e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-75ff-7364-b4e6-35bc82f5216e",
        "storage_key": "property/5638944016302080/019d02ef-75ff-7364-b4e6-35bc82f5216e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJpU5jZKccVIgRkIH8ZTJpCdQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    }
  ],
  "office_hours": [
    {
      "id": "ec_29df86cc203fbf0faad7329e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_39af880e11ad167a6145a4c7",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_9831e81c83e0d74dcd64f065",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_0a1fcdebd2d1b4a675aa1a06",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_117e8dd7fe58f6ff449fead1",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_9c0da2c6f4a1bb50b92a0f00",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_c641e92aa046cd3cbab55875",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "rating": "5",
      "name": "Joshua Fairley",
      "text": "The Elliott is a wonderful place to call home! What really makes this community stand out is the exceptional property manager, Kayla. Since the day I moved in, she has been incredibly helpful with any situation that has come up. Her punctuality, professionalism, and genuine sense of urgency show how much she truly cares about the residents. It’s rare to find someone so dedicated and compassionate, and Kayla consistently goes above and beyond to make sure everything is handled quickly and efficiently. I’m grateful to have such attentive management and highly recommend this community to anyone looking for a place where residents are genuinely valued!",
      "date": "2026-04-30",
      "title": "false"
    },
    {
      "id": "ec_c2e621082863ac3389ddbe11",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "rating": "5",
      "name": "Imani Akira",
      "text": "I moved out in August but I forgot to leave a review so here we are! I moved in originally in July 2024. I stayed a little over a year. I would say that this place is amazing to anyone thinking of renting here. Kayla and Nash have ALWAYS been my favorite and always made it a point to help out with whatever was brought to their attention. Their second chance program for renters is amazing as well. Maintenance always came in a very timely manner, sometimes within minutes of you making a work order. All of the amenities are great, I'm just upset I never made time to get down to the awesome movie theater. I had a 1br, 1 den apt with what I feel like what a a great rental rate, and it was a blessing to have. I would 100% recommend as it always felt like home since the beginning to end. Logan came in around the time I was leaving just a couples months prior and he was always nice. Always called and checked in after work orders.",
      "date": "2025-11-28",
      "title": "false"
    },
    {
      "id": "ec_248bd8916c45423f62325476",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "rating": "5",
      "name": "Kailyn Robinson",
      "text": "I came by recently just to tour apartments in the area but was pleasantly surprised about how helpful the ladies in the leasing office were, especially Janiyah. She was so attentive and answered any and every question I had regarding the community while we were touring, the community and apartment were very well taken care of. I don't plan to move for some months but the Elliott is at the top of my list!!",
      "date": "2026-05-21",
      "title": "false"
    },
    {
      "id": "ec_b6cbff25333f789d2ad5f764",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "rating": "5",
      "name": "Lakeisha Williams",
      "text": "The leasing office has always been good, but Logan truly makes all the difference. I’ve been living here for 3 years now, and Logan has been consistently amazing the entire time. I’ve lived in several apartments over the years, and I’ve honestly never had maintenance service this consistently great anywhere else. He always responds quickly, goes above and beyond, and makes sure problems are actually solved — not just temporarily patched. Even when the original plan doesn’t work out, he finds another solution and gets it done. Having someone this reliable makes a huge difference. Truly appreciate all the hard work!",
      "date": "2026-02-20",
      "title": "false"
    },
    {
      "id": "ec_639b4ab174ca3b84d70780cf",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "rating": "5",
      "name": "Cody Beatty",
      "text": "I requested information from 5 different apartments in the Concord/Charlotte area and The Elliot was the only one who got back to me with a real person.\n\nPaige reached out to me and made this so easy. We are moving from Florida to NC and she made the process of finding a place to live smooth for me and my family.",
      "date": "2026-03-25",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_e996564b-6779-43a2-be1e-542070696a2b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-b73e-7212-ae0e-66078e6bfc4a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Stylish living room with a couch, armchair, coffee table, and TV.",
        "public_id": "019d02ef-b73e-7212-ae0e-66078e6bfc4a",
        "storage_key": "property/5638944016302080/019d02ef-b73e-7212-ae0e-66078e6bfc4a.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "B3 - 2BR, 2BA - 1,056 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=o5eT6QFboXi"
    },
    {
      "id": "custom_5797d8ce-183e-4bed-b3ff-3143b1a40ee2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-b72d-776f-9603-ba8e3b8eebc1.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Movie theater room with plush seating and a projector screen.",
        "public_id": "019d02ef-b72d-776f-9603-ba8e3b8eebc1",
        "storage_key": "property/5638944016302080/019d02ef-b72d-776f-9603-ba8e3b8eebc1.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "Movie Theater",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=5d72GhEghiY"
    },
    {
      "id": "custom_9c4bbc2c-3f28-421b-b205-8dc8ae634a35",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-c109-7758-bbcf-a78253921a4d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Elegant hallway with grand wooden pillars, potted plants, and double doors leading to apartments.",
        "public_id": "019d02ef-c109-7758-bbcf-a78253921a4d",
        "storage_key": "property/5638944016302080/019d02ef-c109-7758-bbcf-a78253921a4d.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "Club House",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=3KTyA3qQU9b"
    },
    {
      "id": "custom_a190fc77-d5af-4667-9ba4-2a3f7ad9a8cc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ef-bfc4-70aa-9f18-b8cc37edcf2a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Gym with treadmills, weight racks, and graffiti art.",
        "public_id": "019d02ef-bfc4-70aa-9f18-b8cc37edcf2a",
        "storage_key": "property/5638944016302080/019d02ef-bfc4-70aa-9f18-b8cc37edcf2a.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "CrossFit Gym and Spin Studio",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=GmR56TRLoe2"
    },
    {
      "id": "custom_6b0be2ff-ceea-4310-b37c-fe2d9913c3aa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02f0-4bdd-747e-b778-471da26a9669.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019d02f0-4bdd-747e-b778-471da26a9669",
        "storage_key": "property/5638944016302080/019d02f0-4bdd-747e-b778-471da26a9669.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Pool",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=1FdE44Mkj6d"
    },
    {
      "id": "custom_1a24ecb5-0882-42c9-9bfb-0fa197d47eab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "A 2-bedroom, 2-bathroom apartment home in Kannapolis, NC, featuring a modern kitchen, open living area, dedicated laundry room, and a walk-in closet.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d75e1-e3c4-77ed-94d7-a79f6a3f45fa.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d75e1-e3c4-77ed-94d7-a79f6a3f45fa",
        "storage_key": "property/5638944016302080/019d75e1-e3c4-77ed-94d7-a79f6a3f45fa.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "B1 | 2 Bedrooms & 2 Bathrooms - 1116 Sq.Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=WE93TdwAUsQ"
    },
    {
      "id": "custom_507e45e2-72a9-4661-a8b1-5ccbce2c797c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f14c3-24b0-7516-8f19-223f17c40af0.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c3-24b0-7516-8f19-223f17c40af0",
        "storage_key": "property/5638944016302080/019f14c3-24b0-7516-8f19-223f17c40af0.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "The Elliott - Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/VVqcSe6EuuM"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa46-1e85-777c-8e15-1ea6d4c83ad8",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "the-elliott",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080"
    },
    {
      "lead_collector_id": "0198aa46-1ee7-75c9-99ed-acc843931e93",
      "lead_source": "FACEBOOK_ADS",
      "name": "the-elliott",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080"
    },
    {
      "lead_collector_id": "0198aa46-1f4a-72bf-a709-1c4e0805d9e4",
      "lead_source": "LANDING_PAGE",
      "name": "the-elliott",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "page_item_url": "luxury-apartments-with-pool-concord-nc-735",
      "search_query": "luxury apartments with pool in Concord NC",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Concord, NC",
      "h2_subtitle": "Discover luxury living in Concord, NC, with a pool retreat. Explore The Elliott to find the apartment that suits your lifestyle.",
      "page_copy": "Experience the pinnacle of luxury at The Elliott, where our Concord, NC, community features a stunning pool for relaxation and recreation. Our luxury apartments, designed with elegant crown molding and modern conveniences like microwaves and dishwashers, offer a welcoming environment that exudes comfort. \n\nIn addition to the sparkling pool, residents can enjoy a plethora of amenities, including a state-of-the-art fitness center and vibrant dog park. Choose from our selection of one, two, or three-bedroom floor plans and take advantage of the pet washing station for added convenience. Schedule a tour today and discover your new home in Cabarrus County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f6c12-68f2-7457-9199-88df0d45d67e.webp",
      "featured_image_media": {
        "alt_text": "Living room with a sectional sofa, coffee table, and TV.",
        "public_id": "019f6c12-68f2-7457-9199-88df0d45d67e",
        "storage_key": "property/5638944016302080/019f6c12-68f2-7457-9199-88df0d45d67e.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in Concord, NC",
      "seo_description": "Explore luxury living at The Elliott in Concord, NC. Enjoy stylish apartments with a pool and top-notch amenities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-dog-park-cabarrus-county-606",
      "search_query": "pet friendly apartments with dog park in Cabarrus County",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Cabarrus County",
      "h2_subtitle": "Live in a pet-friendly community with a dog park in Cabarrus County. The Elliott offers amenities perfect for you and your furry friend.",
      "page_copy": "Welcome to The Elliott, a vibrant community in Cabarrus County that welcomes both you and your furry companions. Our pet-friendly apartments come equipped with a fantastic on-site dog park, ideal for exercise and socializing. Whether you’re relaxing in a stylish one-bedroom or spreading out in a spacious three-bedroom floor plan, you'll enjoy modern conveniences such as a dishwasher and microwave.\n\nThe Elliott not only caters to pets with its dog park but also offers a convenient pet washing station, making it easy to keep your pet clean. Residents can enjoy additional amenities, including a refreshing pool and a state-of-the-art fitness center, ensuring a balanced lifestyle for everyone. Come and see why The Elliott is the perfect home for you and your pet in Concord, NC.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f6c12-68f2-7457-9199-88df0d45d67e.webp",
      "featured_image_media": {
        "alt_text": "Living room with a sectional sofa, coffee table, and TV.",
        "public_id": "019f6c12-68f2-7457-9199-88df0d45d67e",
        "storage_key": "property/5638944016302080/019f6c12-68f2-7457-9199-88df0d45d67e.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Cabarrus County",
      "seo_description": "Find pet-friendly apartments with a dog park at The Elliott in Cabarrus County. Experience ideal living for you and your pet today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "page_item_url": "concord-nc-apartments-laundry-ac-836",
      "search_query": "Concord NC apartments with in-unit laundry and air conditioning",
      "category": "Amenity",
      "h1_title": "Concord NC Apartments with Laundry & A/C",
      "h2_subtitle": "Find comfort in Concord, NC, with in-unit laundry and air conditioning. Explore The Elliott's modern apartments today.",
      "page_copy": "At The Elliott in Concord, discover the convenience of in-unit laundry combined with the comfort of air conditioning in our stylish apartments. Nestled in the heart of Cabarrus County, our community provides residents with a range of floor plans, each thoughtfully designed with modern amenities such as microwaves and dishwashers.\n\nOur apartments offer more than just functional conveniences; they embody a lifestyle. Enjoy exclusive access to our refreshing pool, state-of-the-art fitness center, and vibrant dog park. Experience the ease of living in a community that prioritizes comfort and convenience—schedule a tour to explore all that The Elliott has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f6c12-68f2-7457-9199-88df0d45d67e.webp",
      "featured_image_media": {
        "alt_text": "Living room with a sectional sofa, coffee table, and TV.",
        "public_id": "019f6c12-68f2-7457-9199-88df0d45d67e",
        "storage_key": "property/5638944016302080/019f6c12-68f2-7457-9199-88df0d45d67e.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Concord NC Apartments with Laundry & A/C",
      "seo_description": "Experience comfort at The Elliott with in-unit laundry and air conditioning. Discover Concord, NC living today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "page_item_url": "modern-apartments-fitness-center-concord-28027-853",
      "search_query": "modern apartments with fitness center in Concord 28027",
      "category": "Amenity",
      "h1_title": "Modern Apartments with Fitness Center in Concord",
      "h2_subtitle": "Explore modern living in Concord, 28027, featuring top amenities. The Elliott's fitness center enhances your active lifestyle.",
      "page_copy": "Discover the epitome of modern apartment living at The Elliott, located in Concord, 28027. Our community stands out with its state-of-the-art fitness center, ready to meet all your workout needs. Choose from our variety of stylish floor plans, each offering the convenience of modern amenities like crown molding and a fully equipped kitchen with a microwave and dishwasher.\n\nBeyond your apartment, enjoy community features including a refreshing pool and a vibrant dog park. At The Elliott, every detail is crafted to enhance your lifestyle. Join our community in Cabarrus County and experience the blend of comfort and modernity in a location that supports your active lifestyle. Schedule a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f6c12-68f2-7457-9199-88df0d45d67e.webp",
      "featured_image_media": {
        "alt_text": "Living room with a sectional sofa, coffee table, and TV.",
        "public_id": "019f6c12-68f2-7457-9199-88df0d45d67e",
        "storage_key": "property/5638944016302080/019f6c12-68f2-7457-9199-88df0d45d67e.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apartments with Fitness Center in Concord",
      "seo_description": "Live in style at The Elliott, Concord's modern apartments with a fitness center. Experience unparalleled amenities today in the heart of 28027.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "page_item_url": "apartments-clubhouse-social-areas-concord-nc-980",
      "search_query": "apartments with clubhouse and social areas in Concord NC",
      "category": "Amenity",
      "h1_title": "Apartments with Clubhouse in Concord NC",
      "h2_subtitle": "Join a vibrant community in Concord with inviting social areas. The Elliott offers a welcoming clubhouse for residents.",
      "page_copy": "Welcome to The Elliott, where community living in Concord, NC, is truly elevated. Our modern apartments feature a welcoming clubhouse, perfect for social gatherings and community events. With stylish floor plans ranging from one to three bedrooms, you'll find the perfect space to call home, complete with conveniences like microwaves and dishwashers.\n\nThe social areas at The Elliott are designed to encourage interaction and relaxation. Enjoy the pet-friendly environment with amenities such as a dog park and a refreshing pool. Located in the serene Cabarrus County, our community fosters connections and provides numerous reasons to love living here. Discover why The Elliott in Concord is the ideal place for social living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f6c12-68f2-7457-9199-88df0d45d67e.webp",
      "featured_image_media": {
        "alt_text": "Living room with a sectional sofa, coffee table, and TV.",
        "public_id": "019f6c12-68f2-7457-9199-88df0d45d67e",
        "storage_key": "property/5638944016302080/019f6c12-68f2-7457-9199-88df0d45d67e.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Clubhouse in Concord NC",
      "seo_description": "Discover The Elliott, Concord NC's spot for apartments with a clubhouse and social areas. Join our vibrant community today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-concord-nc-356",
      "search_query": "one bedroom apartments Concord NC",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Concord NC",
      "h2_subtitle": "Explore the ideal one bedroom apartments at The Elliott in Concord, NC. Enjoy modern living with convenient amenities.",
      "page_copy": "At The Elliott, located in Concord, NC, discover why our one bedroom apartments are the perfect fit for your lifestyle. Designed with contemporary style and functionality, each apartment features essential amenities including in-unit laundry, air conditioning, and sleek appliances like a microwave and dishwasher.\n\nOur one bedroom apartments provide not only a comfortable living space but also access to exceptional community amenities. Unwind by the pool, stay active in our fitness center, or enjoy quality time at our dog park. Nestled in the vibrant community of Cabarrus County, The Elliott is your gateway to modern living in Concord. Schedule a tour today and make your one bedroom apartment dream a reality.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f6c12-68f2-7457-9199-88df0d45d67e.webp",
      "featured_image_media": {
        "alt_text": "Living room with a sectional sofa, coffee table, and TV.",
        "public_id": "019f6c12-68f2-7457-9199-88df0d45d67e",
        "storage_key": "property/5638944016302080/019f6c12-68f2-7457-9199-88df0d45d67e.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Concord NC",
      "seo_description": "Find your ideal one bedroom apartment at The Elliott in Concord, NC. Enjoy modern amenities and vibrant community living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-near-28027-847",
      "search_query": "two bedroom apartments near 28027",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments near 28027",
      "h2_subtitle": "Discover spacious two bedroom apartments near 28027 at The Elliott. Enjoy modern living and exceptional amenities in Concord.",
      "page_copy": "Searching for the perfect two bedroom apartment near the 28027 area? Look no further than The Elliott in Concord, NC. Our spacious two bedroom floor plans are designed with modern conveniences such as in-unit laundry, a dishwasher, and a microwave, ensuring a comfortable and stylish living environment.\n\nResiding at The Elliott means access to top-tier community amenities, including a state-of-the-art fitness center, a refreshing swimming pool, and a vibrant dog park. Nestled in Cabarrus County, The Elliott offers a convenient location combined with luxury living. Schedule a tour to experience the lifestyle our two bedroom apartments can offer you in the heart of Concord.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f6c12-68f2-7457-9199-88df0d45d67e.webp",
      "featured_image_media": {
        "alt_text": "Living room with a sectional sofa, coffee table, and TV.",
        "public_id": "019f6c12-68f2-7457-9199-88df0d45d67e",
        "storage_key": "property/5638944016302080/019f6c12-68f2-7457-9199-88df0d45d67e.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments near 28027",
      "seo_description": "Find spacious two bedroom apartments at The Elliott near 28027. Enjoy modern amenities and community features in Concord, NC.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5638944016302080",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-cabarrus-county-nc-219",
      "search_query": "three bedroom apartments Cabarrus County NC",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Cabarrus County NC",
      "h2_subtitle": "Discover exceptional three bedroom apartments in Cabarrus County, NC at The Elliott. Experience spacious living today.",
      "page_copy": "The Elliott proudly presents our spacious three bedroom apartments, perfectly situated in the heart of Cabarrus County, NC. These expansive floor plans cater to the needs of families or those seeking extra space, featuring vital amenities such as in-unit laundry, a dishwasher, and a microwave, enhancing daily convenience and comfort.\n\nLiving at The Elliott offers more than just a place to stay. Our community boasts premium amenities, including a state-of-the-art fitness center, an inviting pool, and a pet-friendly dog park. Located in Concord, NC, The Elliott provides both a tranquil ambiance and proximity to local attractions. Discover the advantages of three bedroom apartment living at The Elliott today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019f6c12-68f2-7457-9199-88df0d45d67e.webp",
      "featured_image_media": {
        "alt_text": "Living room with a sectional sofa, coffee table, and TV.",
        "public_id": "019f6c12-68f2-7457-9199-88df0d45d67e",
        "storage_key": "property/5638944016302080/019f6c12-68f2-7457-9199-88df0d45d67e.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Cabarrus County NC",
      "seo_description": "Explore spacious three bedroom apartments at The Elliott in Cabarrus County, NC. Enjoy modern conveniences and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2204"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376471127"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a54\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a54\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4917513"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-P7KMQSW"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "3"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443201070"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "010c2e40d31811f1"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/yjp2kmjepxl"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/16bd9e51-b6c3-45af-ac31-ca7de98aa060"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "980-304-3577"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InJUV2wwRUpJOW9DbHg3OFFoOGdtT3c9PSIsInZhbHVlIjoiUXBTTTduSDRaUEdLckxzRVE2UkQydz09IiwibWFjIjoiM2MyNzIwYTUzNmI0ZWM5ODBlOGU3NzIxM2QwMzZhOGRkMTA5N2U4MTIyYjAwNmI2YzBiOTM3YTZjNmU0ZGQ3ZiJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2204",
  "custom_repli_id": "2376471127",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a54\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a54\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4917513",
  "custom_google_gtm_id": "GTM-P7KMQSW",
  "custom_rollout_phase": "3",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443201070",
  "custom_knock_community_id": "010c2e40d31811f1",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/yjp2kmjepxl",
  "custom_self_guided_tour_url": "https://selftournow.com/property/16bd9e51-b6c3-45af-ac31-ca7de98aa060",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "980-304-3577",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InJUV2wwRUpJOW9DbHg3OFFoOGdtT3c9PSIsInZhbHVlIjoiUXBTTTduSDRaUEdLckxzRVE2UkQydz09IiwibWFjIjoiM2MyNzIwYTUzNmI0ZWM5ODBlOGU3NzIxM2QwMzZhOGRkMTA5N2U4MTIyYjAwNmI2YzBiOTM3YTZjNmU0ZGQ3ZiJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "55cf66d5-81e3-4163-9c1b-d88aa7304040",
  "custom_audioeye_site_hash": "8c890201ef41142f5b793f8421d24758"
};

export const generatedAt = '2026-11-03T20:31:02.330Z';
